(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["backup-before-reference-rebuild-20260920"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-mtx]');
  if(!root)return;

  var stage=root.querySelector('[data-stage]');
  var product=root.querySelector('[data-product]');
  var halo=root.querySelector('[data-halo]');
  var shadow=root.querySelector('[data-shadow]');
  var mist=root.querySelector('[data-mist]');
  var breathe=root.querySelector('[data-breathe]');
  var chapters=Array.prototype.slice.call(root.querySelectorAll('[data-chapter]'));
  var dots=Array.prototype.slice.call(root.querySelectorAll('[data-dots] i'));
  var progress=root.querySelector('[data-progress]');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active=-1;
  var raf=0;
  var story=root.querySelector('[data-story]');
  var stageHome=stage&&stage.parentNode;
  var stagePortaled=false;

  function portalMetrics(){
    var w=window.innerWidth||document.documentElement.clientWidth;
    var vh=viewportH();
    var mobile=w<=980;
    var tiny=w<=640;
    var wrap=stageHome&&stageHome.getBoundingClientRect?stageHome.getBoundingClientRect():null;
    if(mobile){
      return {
        top:tiny?72:68,
        left:0,
        width:w,
        height:Math.max(tiny?300:320,Math.round(vh*(tiny?.46:.47))),
        minH:tiny?300:320
      };
    }
    var left=wrap?wrap.left:Math.max(24,(w-1320)/2);
    var width=wrap&&wrap.width?wrap.width:Math.min(520,w*.4);
    return {
      top:96,
      left:left,
      width:width,
      height:Math.max(620,vh-120),
      minH:620
    };
  }

  function mountStagePortal(){
    if(!stage||!stageHome)return;
    if(stage.parentNode!==document.body)document.body.appendChild(stage);
    stagePortaled=true;
    stage.classList.add('mtx-stage--portal');
    var m=portalMetrics();
    stage.style.setProperty('--mtx-portal-top',m.top+'px');
    stage.style.setProperty('--mtx-portal-left',m.left+'px');
    stage.style.setProperty('--mtx-portal-width',m.width+'px');
    stage.style.setProperty('--mtx-portal-height',m.height+'px');
    stage.style.setProperty('--mtx-portal-minh',m.minH+'px');
  }

  function restoreStageHome(){
    if(!stage||!stageHome||!stagePortaled)return;
    stageHome.appendChild(stage);
    stagePortaled=false;
    stage.classList.remove('mtx-stage--portal');
    stage.style.removeProperty('--mtx-portal-top');
    stage.style.removeProperty('--mtx-portal-left');
    stage.style.removeProperty('--mtx-portal-width');
    stage.style.removeProperty('--mtx-portal-height');
    stage.style.removeProperty('--mtx-portal-minh');
  }

  function updateStagePortal(){
    if(!story||!stage||!stageHome)return;
    var r=story.getBoundingClientRect();
    var m=portalMetrics();
    var enterLine=m.top+4;
    var leaveLine=m.top+Math.min(m.height,viewportH()-m.top);
    var shouldPin=r.top<=enterLine && r.bottom>leaveLine;
    if(shouldPin)mountStagePortal();
    else restoreStageHome();
  }

  var states=[
    {x:50,y:54,s:.92,h:1,shadow:1,mist:0,breathe:0},
    {x:50,y:38,s:1.42,h:.94,shadow:.65,mist:0,breathe:0},
    {x:50,y:62,s:1.36,h:.92,shadow:.6,mist:0,breathe:0},
    {x:48,y:52,s:1.02,h:.96,shadow:1,mist:0,breathe:0},
    {x:39,y:52,s:1.08,h:.9,shadow:.88,mist:1,breathe:0},
    {x:50,y:52,s:.96,h:1.08,shadow:.92,mist:0,breathe:1}
  ];

  function clamp(v,min,max){return Math.max(min,Math.min(max,v))}
  function mix(a,b,t){return a+(b-a)*t}
  function viewportH(){return window.innerHeight||document.documentElement.clientHeight}

  function storyProgress(){
    if(!chapters.length)return 0;
    var first=chapters[0].getBoundingClientRect();
    var last=chapters[chapters.length-1].getBoundingClientRect();
    var vh=viewportH();
    var center=vh*.52;
    var start=first.top+window.scrollY;
    var end=last.bottom+window.scrollY;
    var y=window.scrollY+center;
    return clamp((y-start)/(end-start),0,1)*(states.length-1);
  }

  function applyState(p){
    var i=Math.floor(p);
    var j=Math.min(states.length-1,i+1);
    var t=clamp(p-i,0,1);
    var a=states[i],b=states[j];
    var x=mix(a.x,b.x,t);
    var y=mix(a.y,b.y,t);
    var s=mix(a.s,b.s,t);
    var h=mix(a.h,b.h,t);
    var sh=mix(a.shadow,b.shadow,t);
    product.style.left=x+'%';
    product.style.top=y+'%';
    product.style.transform='translate(-50%,-50%) scale('+s+')';
    halo.style.transform='translate(-50%,-50%) scale('+h+')';
    shadow.style.opacity=String(sh);

    var idx=Math.round(p);
    if(idx!==active){
      active=idx;
      chapters.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      dots.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      var mistOn=states[idx].mist>0;
      var breatheOn=states[idx].breathe>0;
      mist.style.opacity=mistOn?'1':'0';
      breathe.style.opacity=breatheOn?'1':'0';
      mistActive=mistOn&&!reduce;
      if(mistActive)startMist(); else stopMist();
    }
  }

  function updateProgress(){
    var doc=document.documentElement;
    var max=Math.max(1,doc.scrollHeight-viewportH());
    var v=clamp(window.scrollY/max,0,1);
    progress.style.width=(v*100).toFixed(2)+'%';
  }

  function render(){
    raf=0;
    updateStagePortal();
    if(story){
      var r=story.getBoundingClientRect();
      if(r.bottom>0&&r.top<viewportH()){
        applyState(storyProgress());
      }
    }
    updateProgress();
  }
  function onScroll(){if(!raf)raf=requestAnimationFrame(render)}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){updateStagePortal();onScroll()},{passive:true});

  var ctx=mist&&mist.getContext?mist.getContext('2d'):null;
  var particles=[];
  var mistRaf=0;
  var mistActive=false;
  var lastTime=0;

  function resizeMist(){
    if(!ctx)return;
    var dpr=Math.min(2,window.devicePixelRatio||1);
    var rect=stage.getBoundingClientRect();
    mist.width=Math.max(1,Math.round(rect.width*dpr));
    mist.height=Math.max(1,Math.round(rect.height*dpr));
    mist.style.width=rect.width+'px';
    mist.style.height=rect.height+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }

  function spawnMist(w,h){
    var rect=product.getBoundingClientRect();
    var stageRect=stage.getBoundingClientRect();
    var ox=rect.right-stageRect.left-rect.width*.14;
    var oy=rect.top-stageRect.top+rect.height*.27;
    var count=window.innerWidth<700?5:8;
    for(var i=0;i<count;i++){
      particles.push({
        x:ox+(Math.random()*6-3),
        y:oy+(Math.random()*8-4),
        vx:(1.35+Math.random()*1.9)*(window.innerWidth<700?.88:1),
        vy:(Math.random()-.5)*.7,
        life:1,
        r:.7+Math.random()*2.7,
        z:Math.random(),
        drift:Math.random()*Math.PI*2
      });
    }
    if(particles.length>250)particles.splice(0,particles.length-250);
  }

  function drawMist(ts){
    if(!ctx||!mistActive){mistRaf=0;return}
    var rect=stage.getBoundingClientRect();
    var w=rect.width,h=rect.height;
    var dt=Math.min(32,ts-(lastTime||ts))/16.67;
    lastTime=ts;
    ctx.clearRect(0,0,w,h);
    spawnMist(w,h);

    for(var i=particles.length-1;i>=0;i--){
      var p=particles[i];
      p.x+=p.vx*dt*(1+p.z*.6);
      p.y+=p.vy*dt+Math.sin(p.drift+p.x*.02)*.14;
      p.vx*=1.003;
      p.life-=.012*dt*(.8+p.z*.45);
      p.r+=.018*dt;
      if(p.life<=0||p.x>w+30){particles.splice(i,1);continue}

      var a=Math.max(0,p.life)*(.08+.15*p.z);
      var grad=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*4);
      grad.addColorStop(0,'rgba(255,255,255,'+a+')');
      grad.addColorStop(.4,'rgba(232,207,194,'+(a*.55)+')');
      grad.addColorStop(1,'rgba(232,207,194,0)');
      ctx.fillStyle=grad;
      ctx.beginPath();
      ctx.arc(p.x,p.y,p.r*4,0,Math.PI*2);
      ctx.fill();
    }
    mistRaf=requestAnimationFrame(drawMist);
  }
  function startMist(){
    if(!ctx||mistRaf||reduce)return;
    resizeMist();
    mistRaf=requestAnimationFrame(drawMist);
  }
  function stopMist(){
    mistActive=false;
    if(mistRaf){cancelAnimationFrame(mistRaf);mistRaf=0}
    if(ctx){
      var rect=stage.getBoundingClientRect();
      ctx.clearRect(0,0,rect.width,rect.height);
    }
    particles=[];
  }
  window.addEventListener('resize',resizeMist,{passive:true});

  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(){
      var id=a.getAttribute('href');
      var target=id&&document.querySelector(id);
      if(!target)return;
      setTimeout(function(){target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'})},0);
    });
  });

  window.addEventListener('pagehide',restoreStageHome,{once:true});
  render();
  resizeMist();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["backup-before-responsive-pro-20260920"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}

  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var cream=root.querySelector("[data-bg-cream]");
    var shadow=root.querySelector("[data-shadow]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function syncViewportHeight(){
      if(window.innerWidth>720){
        root.style.removeProperty("--mtx-vh");
        return;
      }
      var h=(window.visualViewport&&window.visualViewport.height)||window.innerHeight||document.documentElement.clientHeight;
      if(h>0)root.style.setProperty("--mtx-vh",Math.round(h)+"px");
    }
    syncViewportHeight();

    var active=-1;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var desktopFrames=[
      {x:68,y:51,s:1.00,light:0,halo:.92,orbit:.58},
      {x:67,y:50,s:1.07,light:1,halo:.72,orbit:.18},
      {x:35,y:50,s:1.14,light:1,halo:.64,orbit:.10},
      {x:69,y:66,s:1.50,light:1,halo:.48,orbit:.00},
      {x:31,y:36,s:1.48,light:1,halo:.46,orbit:.00},
      {x:69,y:50,s:.86,light:0,halo:.72,orbit:.26},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:.92,light:0,halo:.80,orbit:.00},
      {x:69,y:50,s:1.08,light:0,halo:.82,orbit:.24},
      {x:78,y:49,s:.68,light:1,halo:.50,orbit:.12}
    ];

    var tabletFrames=[
      {x:67,y:51,s:.96,light:0,halo:.90,orbit:.50},
      {x:66,y:50,s:1.00,light:1,halo:.70,orbit:.16},
      {x:34,y:50,s:1.04,light:1,halo:.62,orbit:.10},
      {x:67,y:62,s:1.24,light:1,halo:.48,orbit:.00},
      {x:33,y:38,s:1.22,light:1,halo:.46,orbit:.00},
      {x:67,y:50,s:.84,light:0,halo:.70,orbit:.22},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.89,light:0,halo:.78,orbit:.00},
      {x:67,y:50,s:1.00,light:0,halo:.80,orbit:.20},
      {x:76,y:49,s:.66,light:1,halo:.48,orbit:.10}
    ];

    var mobileFrames=[
      {x:68,y:26.0,s:.94,light:0,halo:.86,orbit:.44},
      {x:63,y:25.5,s:1.05,light:.10,halo:.74,orbit:.28},
      {x:35,y:26.0,s:1.13,light:.18,halo:.70,orbit:.20},
      {x:66,y:22.5,s:1.26,light:.22,halo:.64,orbit:.12},
      {x:34,y:23.5,s:1.23,light:.26,halo:.62,orbit:.10},
      {x:64,y:26.0,s:.91,light:.10,halo:.74,orbit:.20},
      {x:36,y:26.0,s:1.02,light:.08,halo:.76,orbit:.12},
      {x:36,y:25.5,s:1.08,light:.08,halo:.78,orbit:.10},
      {x:50,y:25.5,s:.93,light:.06,halo:.82,orbit:.10},
      {x:64,y:26.0,s:1.06,light:.10,halo:.82,orbit:.18},
      {x:70,y:25.0,s:.80,light:.18,halo:.68,orbit:.12}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop;
    }
    function viewportH(){
      return scroller===window?(window.innerHeight||document.documentElement.clientHeight):scroller.clientHeight;
    }
    function storyTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top);
    }
    function timelineProgress(){
      if(!steps.length)return 0;
      var base=scroller===window?0:scroller.getBoundingClientRect().top;
      var marker=viewportH()*.52;
      var centers=steps.map(function(step){
        var r=step.getBoundingClientRect();
        return (r.top-base)+r.height*.5;
      });
      if(marker<=centers[0])return 0;
      var last=centers.length-1;
      if(marker>=centers[last])return 1;
      for(var i=0;i<last;i++){
        if(marker>=centers[i]&&marker<=centers[i+1]){
          var span=Math.max(1,centers[i+1]-centers[i]);
          var local=(marker-centers[i])/span;
          return (i+clamp(local,0,1))/last;
        }
      }
      return 0;
    }
    function activeFromViewport(){
      if(window.innerWidth<=720){
        var base=scroller===window?0:scroller.getBoundingClientRect().top;
        var vh=viewportH();
        var best=0;
        var bestVisible=-1;
        steps.forEach(function(step,i){
          var r=step.getBoundingClientRect();
          var top=r.top-base;
          var bottom=r.bottom-base;
          var visible=Math.max(0,Math.min(bottom,vh)-Math.max(top,0));
          if(visible>bestVisible){
            bestVisible=visible;
            best=i;
          }
        });
        return best;
      }
      return Math.round(timelineProgress()*(steps.length-1));
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i)return;
      active=i;
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",false);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var frames=window.innerWidth<=720?mobileFrames:(window.innerWidth<=1100?tabletFrames:desktopFrames);
      var n=frames.length-1;
      var exact=clamp(p,0,1)*n;
      var a=Math.floor(exact);
      var b=Math.min(n,a+1);
      var t=ease(exact-a);
      var fa=frames[a],fb=frames[b];

      var x=lerp(fa.x,fb.x,t);
      var y=lerp(fa.y,fb.y,t);
      var s=lerp(fa.s,fb.s,t);
      var light=lerp(fa.light,fb.light,t);
      var haloOpacity=lerp(fa.halo,fb.halo,t);
      var orbitOpacity=lerp(fa.orbit,fb.orbit,t);

      product.style.left=x+"%";
      product.style.top=y+"%";
      product.style.transform="translate3d(-50%,-50%,0) scale("+s+")";
      if(window.innerWidth<=720){
        spray.style.left=x+"%";
        spray.style.top=y+"%";
        breath.style.left=x+"%";
        breath.style.top=y+"%";
      }
      halo.style.left=x+"%";
      halo.style.top=y+"%";
      orbitOne.style.left=x+"%";
      orbitOne.style.top=y+"%";
      orbitTwo.style.left=x+"%";
      orbitTwo.style.top=y+"%";
      dotOne.style.left=x+"%";
      dotOne.style.top=y+"%";
      dotTwo.style.left=x+"%";
      dotTwo.style.top=y+"%";

      cream.style.opacity=light.toFixed(3);
      halo.style.opacity=haloOpacity.toFixed(3);
      orbitOne.style.opacity=orbitOpacity.toFixed(3);
      orbitTwo.style.opacity=(orbitOpacity*.62).toFixed(3);
      dotOne.style.opacity=(orbitOpacity*.92).toFixed(3);
      dotTwo.style.opacity=(orbitOpacity*.72).toFixed(3);
      shadow.style.opacity=clamp(.82-(s-1)*.18,.48,.88).toFixed(3);

      var rot=p*360;
      orbitOne.style.transform="translate3d(-50%,-50%,0) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate3d(-50%,-50%,0) rotate("+(-rot*.78)+"deg)";

      var mobile=window.innerWidth<=720;
      var r1=Math.min(282,window.innerWidth*(mobile?.34:.18));
      var r2=Math.min(198,window.innerWidth*(mobile?.23:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.78)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100).toFixed(2)+"%";
    }
    function tick(){
      currentP+=(targetP-currentP)*.16;
      if(Math.abs(targetP-currentP)<.0005)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0005){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=timelineProgress();
      setActive(activeFromViewport());
      if(reduced){
        currentP=targetP;
        stageRender(currentP);
        return;
      }
      if(!raf)raf=requestAnimationFrame(tick);
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }
    }

    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)});
    });

    if(stage&&!reduced&&window.matchMedia("(pointer:fine)").matches){
      stage.addEventListener("pointermove",function(e){
        var r=stage.getBoundingClientRect();
        var px=clamp((e.clientX-r.left)/r.width,0,1)-.5;
        var py=clamp((e.clientY-r.top)/r.height,0,1)-.5;
        productImg.style.setProperty("--tilt-x",(px*2.4).toFixed(2)+"deg");
        productImg.style.setProperty("--tilt-y",(-py*1.8).toFixed(2)+"deg");
      });
      stage.addEventListener("pointerleave",function(){
        productImg.style.setProperty("--tilt-x","0deg");
        productImg.style.setProperty("--tilt-y","0deg");
      });
    }

    scroller.addEventListener("scroll",onScroll,{passive:true});
    if(window.innerWidth<=720){
      document.addEventListener("scroll",onScroll,{passive:true,capture:true});
      window.addEventListener("touchmove",onScroll,{passive:true});
    }
    var resizeRaf=0;
    window.addEventListener("resize",function(){
      syncViewportHeight();
      if(resizeRaf)return;
      resizeRaf=requestAnimationFrame(function(){
        resizeRaf=0;
        var nextScroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
        if(nextScroller!==scroller){
          scroller.removeEventListener("scroll",onScroll);
          scroller=nextScroller;
          scroller.addEventListener("scroll",onScroll,{passive:true});
        }
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      });
    },{passive:true});
    if(window.visualViewport){
      window.visualViewport.addEventListener("resize",syncViewportHeight,{passive:true});
    }
    window.addEventListener("orientationchange",function(){
      setTimeout(function(){
        syncViewportHeight();
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      },120);
    },{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120);
    }
    loaderBar.style.width="62%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700);
    }else done();

    setActive(activeFromViewport());
    targetP=timelineProgress();
    currentP=targetP;
    stageRender(currentP);
  }

  function start(scope){
    (scope||document).querySelectorAll("[data-mtx]").forEach(init);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){start(document)});
  }else{
    start(document);
  }

  document.addEventListener("shopify:section:load",function(e){start(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["backup-before-scroll-fix-20260920"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-mtx]');
  if(!root)return;

  var stage=root.querySelector('[data-stage]');
  var product=root.querySelector('[data-product]');
  var halo=root.querySelector('[data-halo]');
  var shadow=root.querySelector('[data-shadow]');
  var mist=root.querySelector('[data-mist]');
  var breathe=root.querySelector('[data-breathe]');
  var chapters=Array.prototype.slice.call(root.querySelectorAll('[data-chapter]'));
  var dots=Array.prototype.slice.call(root.querySelectorAll('[data-dots] i'));
  var progress=root.querySelector('[data-progress]');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active=-1;
  var raf=0;
  var story=root.querySelector('[data-story]');

  var states=[
    {x:50,y:54,s:.92,h:1,shadow:1,mist:0,breathe:0},
    {x:50,y:38,s:1.42,h:.94,shadow:.65,mist:0,breathe:0},
    {x:50,y:62,s:1.36,h:.92,shadow:.6,mist:0,breathe:0},
    {x:48,y:52,s:1.02,h:.96,shadow:1,mist:0,breathe:0},
    {x:39,y:52,s:1.08,h:.9,shadow:.88,mist:1,breathe:0},
    {x:50,y:52,s:.96,h:1.08,shadow:.92,mist:0,breathe:1}
  ];

  function clamp(v,min,max){return Math.max(min,Math.min(max,v))}
  function mix(a,b,t){return a+(b-a)*t}
  function viewportH(){return window.innerHeight||document.documentElement.clientHeight}

  function storyProgress(){
    if(!chapters.length)return 0;
    var first=chapters[0].getBoundingClientRect();
    var last=chapters[chapters.length-1].getBoundingClientRect();
    var vh=viewportH();
    var center=vh*.52;
    var start=first.top+window.scrollY;
    var end=last.bottom+window.scrollY;
    var y=window.scrollY+center;
    return clamp((y-start)/(end-start),0,1)*(states.length-1);
  }

  function applyState(p){
    var i=Math.floor(p);
    var j=Math.min(states.length-1,i+1);
    var t=clamp(p-i,0,1);
    var a=states[i],b=states[j];
    var x=mix(a.x,b.x,t);
    var y=mix(a.y,b.y,t);
    var s=mix(a.s,b.s,t);
    var h=mix(a.h,b.h,t);
    var sh=mix(a.shadow,b.shadow,t);
    product.style.left=x+'%';
    product.style.top=y+'%';
    product.style.transform='translate(-50%,-50%) scale('+s+')';
    halo.style.transform='translate(-50%,-50%) scale('+h+')';
    shadow.style.opacity=String(sh);

    var idx=Math.round(p);
    if(idx!==active){
      active=idx;
      chapters.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      dots.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      var mistOn=states[idx].mist>0;
      var breatheOn=states[idx].breathe>0;
      mist.style.opacity=mistOn?'1':'0';
      breathe.style.opacity=breatheOn?'1':'0';
      mistActive=mistOn&&!reduce;
      if(mistActive)startMist(); else stopMist();
    }
  }

  function updateProgress(){
    var doc=document.documentElement;
    var max=Math.max(1,doc.scrollHeight-viewportH());
    var v=clamp(window.scrollY/max,0,1);
    progress.style.width=(v*100).toFixed(2)+'%';
  }

  function render(){
    raf=0;
    if(story){
      var r=story.getBoundingClientRect();
      if(r.bottom>0&&r.top<viewportH()){
        applyState(storyProgress());
      }
    }
    updateProgress();
  }
  function onScroll(){if(!raf)raf=requestAnimationFrame(render)}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});

  var ctx=mist&&mist.getContext?mist.getContext('2d'):null;
  var particles=[];
  var mistRaf=0;
  var mistActive=false;
  var lastTime=0;

  function resizeMist(){
    if(!ctx)return;
    var dpr=Math.min(2,window.devicePixelRatio||1);
    var rect=stage.getBoundingClientRect();
    mist.width=Math.max(1,Math.round(rect.width*dpr));
    mist.height=Math.max(1,Math.round(rect.height*dpr));
    mist.style.width=rect.width+'px';
    mist.style.height=rect.height+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }

  function spawnMist(w,h){
    var rect=product.getBoundingClientRect();
    var stageRect=stage.getBoundingClientRect();
    var ox=rect.right-stageRect.left-rect.width*.14;
    var oy=rect.top-stageRect.top+rect.height*.27;
    var count=window.innerWidth<700?5:8;
    for(var i=0;i<count;i++){
      particles.push({
        x:ox+(Math.random()*6-3),
        y:oy+(Math.random()*8-4),
        vx:(1.35+Math.random()*1.9)*(window.innerWidth<700?.88:1),
        vy:(Math.random()-.5)*.7,
        life:1,
        r:.7+Math.random()*2.7,
        z:Math.random(),
        drift:Math.random()*Math.PI*2
      });
    }
    if(particles.length>250)particles.splice(0,particles.length-250);
  }

  function drawMist(ts){
    if(!ctx||!mistActive){mistRaf=0;return}
    var rect=stage.getBoundingClientRect();
    var w=rect.width,h=rect.height;
    var dt=Math.min(32,ts-(lastTime||ts))/16.67;
    lastTime=ts;
    ctx.clearRect(0,0,w,h);
    spawnMist(w,h);

    for(var i=particles.length-1;i>=0;i--){
      var p=particles[i];
      p.x+=p.vx*dt*(1+p.z*.6);
      p.y+=p.vy*dt+Math.sin(p.drift+p.x*.02)*.14;
      p.vx*=1.003;
      p.life-=.012*dt*(.8+p.z*.45);
      p.r+=.018*dt;
      if(p.life<=0||p.x>w+30){particles.splice(i,1);continue}

      var a=Math.max(0,p.life)*(.08+.15*p.z);
      var grad=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*4);
      grad.addColorStop(0,'rgba(255,255,255,'+a+')');
      grad.addColorStop(.4,'rgba(232,207,194,'+(a*.55)+')');
      grad.addColorStop(1,'rgba(232,207,194,0)');
      ctx.fillStyle=grad;
      ctx.beginPath();
      ctx.arc(p.x,p.y,p.r*4,0,Math.PI*2);
      ctx.fill();
    }
    mistRaf=requestAnimationFrame(drawMist);
  }
  function startMist(){
    if(!ctx||mistRaf||reduce)return;
    resizeMist();
    mistRaf=requestAnimationFrame(drawMist);
  }
  function stopMist(){
    mistActive=false;
    if(mistRaf){cancelAnimationFrame(mistRaf);mistRaf=0}
    if(ctx){
      var rect=stage.getBoundingClientRect();
      ctx.clearRect(0,0,rect.width,rect.height);
    }
    particles=[];
  }
  window.addEventListener('resize',resizeMist,{passive:true});

  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(){
      var id=a.getAttribute('href');
      var target=id&&document.querySelector(id);
      if(!target)return;
      setTimeout(function(){target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'})},0);
    });
  });

  render();
  resizeMist();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["backup-before-stage-portal-fix-20260920"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-mtx]');
  if(!root)return;

  var stage=root.querySelector('[data-stage]');
  var product=root.querySelector('[data-product]');
  var halo=root.querySelector('[data-halo]');
  var shadow=root.querySelector('[data-shadow]');
  var mist=root.querySelector('[data-mist]');
  var breathe=root.querySelector('[data-breathe]');
  var chapters=Array.prototype.slice.call(root.querySelectorAll('[data-chapter]'));
  var dots=Array.prototype.slice.call(root.querySelectorAll('[data-dots] i'));
  var progress=root.querySelector('[data-progress]');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active=-1;
  var raf=0;
  var story=root.querySelector('[data-story]');

  var states=[
    {x:50,y:54,s:.92,h:1,shadow:1,mist:0,breathe:0},
    {x:50,y:38,s:1.42,h:.94,shadow:.65,mist:0,breathe:0},
    {x:50,y:62,s:1.36,h:.92,shadow:.6,mist:0,breathe:0},
    {x:48,y:52,s:1.02,h:.96,shadow:1,mist:0,breathe:0},
    {x:39,y:52,s:1.08,h:.9,shadow:.88,mist:1,breathe:0},
    {x:50,y:52,s:.96,h:1.08,shadow:.92,mist:0,breathe:1}
  ];

  function clamp(v,min,max){return Math.max(min,Math.min(max,v))}
  function mix(a,b,t){return a+(b-a)*t}
  function viewportH(){return window.innerHeight||document.documentElement.clientHeight}

  function storyProgress(){
    if(!chapters.length)return 0;
    var first=chapters[0].getBoundingClientRect();
    var last=chapters[chapters.length-1].getBoundingClientRect();
    var vh=viewportH();
    var center=vh*.52;
    var start=first.top+window.scrollY;
    var end=last.bottom+window.scrollY;
    var y=window.scrollY+center;
    return clamp((y-start)/(end-start),0,1)*(states.length-1);
  }

  function applyState(p){
    var i=Math.floor(p);
    var j=Math.min(states.length-1,i+1);
    var t=clamp(p-i,0,1);
    var a=states[i],b=states[j];
    var x=mix(a.x,b.x,t);
    var y=mix(a.y,b.y,t);
    var s=mix(a.s,b.s,t);
    var h=mix(a.h,b.h,t);
    var sh=mix(a.shadow,b.shadow,t);
    product.style.left=x+'%';
    product.style.top=y+'%';
    product.style.transform='translate(-50%,-50%) scale('+s+')';
    halo.style.transform='translate(-50%,-50%) scale('+h+')';
    shadow.style.opacity=String(sh);

    var idx=Math.round(p);
    if(idx!==active){
      active=idx;
      chapters.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      dots.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      var mistOn=states[idx].mist>0;
      var breatheOn=states[idx].breathe>0;
      mist.style.opacity=mistOn?'1':'0';
      breathe.style.opacity=breatheOn?'1':'0';
      mistActive=mistOn&&!reduce;
      if(mistActive)startMist(); else stopMist();
    }
  }

  function updateProgress(){
    var doc=document.documentElement;
    var max=Math.max(1,doc.scrollHeight-viewportH());
    var v=clamp(window.scrollY/max,0,1);
    progress.style.width=(v*100).toFixed(2)+'%';
  }

  function render(){
    raf=0;
    if(story){
      var r=story.getBoundingClientRect();
      if(r.bottom>0&&r.top<viewportH()){
        applyState(storyProgress());
      }
    }
    updateProgress();
  }
  function onScroll(){if(!raf)raf=requestAnimationFrame(render)}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});

  var ctx=mist&&mist.getContext?mist.getContext('2d'):null;
  var particles=[];
  var mistRaf=0;
  var mistActive=false;
  var lastTime=0;

  function resizeMist(){
    if(!ctx)return;
    var dpr=Math.min(2,window.devicePixelRatio||1);
    var rect=stage.getBoundingClientRect();
    mist.width=Math.max(1,Math.round(rect.width*dpr));
    mist.height=Math.max(1,Math.round(rect.height*dpr));
    mist.style.width=rect.width+'px';
    mist.style.height=rect.height+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }

  function spawnMist(w,h){
    var rect=product.getBoundingClientRect();
    var stageRect=stage.getBoundingClientRect();
    var ox=rect.right-stageRect.left-rect.width*.14;
    var oy=rect.top-stageRect.top+rect.height*.27;
    var count=window.innerWidth<700?5:8;
    for(var i=0;i<count;i++){
      particles.push({
        x:ox+(Math.random()*6-3),
        y:oy+(Math.random()*8-4),
        vx:(1.35+Math.random()*1.9)*(window.innerWidth<700?.88:1),
        vy:(Math.random()-.5)*.7,
        life:1,
        r:.7+Math.random()*2.7,
        z:Math.random(),
        drift:Math.random()*Math.PI*2
      });
    }
    if(particles.length>250)particles.splice(0,particles.length-250);
  }

  function drawMist(ts){
    if(!ctx||!mistActive){mistRaf=0;return}
    var rect=stage.getBoundingClientRect();
    var w=rect.width,h=rect.height;
    var dt=Math.min(32,ts-(lastTime||ts))/16.67;
    lastTime=ts;
    ctx.clearRect(0,0,w,h);
    spawnMist(w,h);

    for(var i=particles.length-1;i>=0;i--){
      var p=particles[i];
      p.x+=p.vx*dt*(1+p.z*.6);
      p.y+=p.vy*dt+Math.sin(p.drift+p.x*.02)*.14;
      p.vx*=1.003;
      p.life-=.012*dt*(.8+p.z*.45);
      p.r+=.018*dt;
      if(p.life<=0||p.x>w+30){particles.splice(i,1);continue}

      var a=Math.max(0,p.life)*(.08+.15*p.z);
      var grad=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*4);
      grad.addColorStop(0,'rgba(255,255,255,'+a+')');
      grad.addColorStop(.4,'rgba(232,207,194,'+(a*.55)+')');
      grad.addColorStop(1,'rgba(232,207,194,0)');
      ctx.fillStyle=grad;
      ctx.beginPath();
      ctx.arc(p.x,p.y,p.r*4,0,Math.PI*2);
      ctx.fill();
    }
    mistRaf=requestAnimationFrame(drawMist);
  }
  function startMist(){
    if(!ctx||mistRaf||reduce)return;
    resizeMist();
    mistRaf=requestAnimationFrame(drawMist);
  }
  function stopMist(){
    mistActive=false;
    if(mistRaf){cancelAnimationFrame(mistRaf);mistRaf=0}
    if(ctx){
      var rect=stage.getBoundingClientRect();
      ctx.clearRect(0,0,rect.width,rect.height);
    }
    particles=[];
  }
  window.addEventListener('resize',resizeMist,{passive:true});

  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(){
      var id=a.getAttribute('href');
      var target=id&&document.querySelector(id);
      if(!target)return;
      setTimeout(function(){target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'})},0);
    });
  });

  render();
  resizeMist();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["backup-before-visual-persistence-fix-20260920"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-mtx]');
  if(!root)return;

  var stage=root.querySelector('[data-stage]');
  var product=root.querySelector('[data-product]');
  var halo=root.querySelector('[data-halo]');
  var shadow=root.querySelector('[data-shadow]');
  var mist=root.querySelector('[data-mist]');
  var breathe=root.querySelector('[data-breathe]');
  var chapters=Array.prototype.slice.call(root.querySelectorAll('[data-chapter]'));
  var dots=Array.prototype.slice.call(root.querySelectorAll('[data-dots] i'));
  var progress=root.querySelector('[data-progress]');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active=-1;
  var raf=0;
  var story=root.querySelector('[data-story]');

  var states=[
    {x:50,y:54,s:.92,h:1,shadow:1,mist:0,breathe:0},
    {x:50,y:38,s:1.42,h:.94,shadow:.65,mist:0,breathe:0},
    {x:50,y:62,s:1.36,h:.92,shadow:.6,mist:0,breathe:0},
    {x:48,y:52,s:1.02,h:.96,shadow:1,mist:0,breathe:0},
    {x:39,y:52,s:1.08,h:.9,shadow:.88,mist:1,breathe:0},
    {x:50,y:52,s:.96,h:1.08,shadow:.92,mist:0,breathe:1}
  ];

  function clamp(v,min,max){return Math.max(min,Math.min(max,v))}
  function mix(a,b,t){return a+(b-a)*t}
  function viewportH(){return window.innerHeight||document.documentElement.clientHeight}

  function storyProgress(){
    if(!chapters.length)return 0;
    var first=chapters[0].getBoundingClientRect();
    var last=chapters[chapters.length-1].getBoundingClientRect();
    var vh=viewportH();
    var center=vh*.52;
    var start=first.top+window.scrollY;
    var end=last.bottom+window.scrollY;
    var y=window.scrollY+center;
    return clamp((y-start)/(end-start),0,1)*(states.length-1);
  }

  function applyState(p){
    var i=Math.floor(p);
    var j=Math.min(states.length-1,i+1);
    var t=clamp(p-i,0,1);
    var a=states[i],b=states[j];
    var x=mix(a.x,b.x,t);
    var y=mix(a.y,b.y,t);
    var s=mix(a.s,b.s,t);
    var h=mix(a.h,b.h,t);
    var sh=mix(a.shadow,b.shadow,t);
    product.style.left=x+'%';
    product.style.top=y+'%';
    product.style.transform='translate(-50%,-50%) scale('+s+')';
    halo.style.transform='translate(-50%,-50%) scale('+h+')';
    shadow.style.opacity=String(sh);

    var idx=Math.round(p);
    if(idx!==active){
      active=idx;
      chapters.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      dots.forEach(function(el,n){el.classList.toggle('is-active',n===idx)});
      var mistOn=states[idx].mist>0;
      var breatheOn=states[idx].breathe>0;
      mist.style.opacity=mistOn?'1':'0';
      breathe.style.opacity=breatheOn?'1':'0';
      mistActive=mistOn&&!reduce;
      if(mistActive)startMist(); else stopMist();
    }
  }

  function updateProgress(){
    var doc=document.documentElement;
    var max=Math.max(1,doc.scrollHeight-viewportH());
    var v=clamp(window.scrollY/max,0,1);
    progress.style.width=(v*100).toFixed(2)+'%';
  }

  function render(){
    raf=0;
    if(story){
      var r=story.getBoundingClientRect();
      if(r.bottom>0&&r.top<viewportH()){
        applyState(storyProgress());
      }
    }
    updateProgress();
  }
  function onScroll(){if(!raf)raf=requestAnimationFrame(render)}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});

  var ctx=mist&&mist.getContext?mist.getContext('2d'):null;
  var particles=[];
  var mistRaf=0;
  var mistActive=false;
  var lastTime=0;

  function resizeMist(){
    if(!ctx)return;
    var dpr=Math.min(2,window.devicePixelRatio||1);
    var rect=stage.getBoundingClientRect();
    mist.width=Math.max(1,Math.round(rect.width*dpr));
    mist.height=Math.max(1,Math.round(rect.height*dpr));
    mist.style.width=rect.width+'px';
    mist.style.height=rect.height+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }

  function spawnMist(w,h){
    var rect=product.getBoundingClientRect();
    var stageRect=stage.getBoundingClientRect();
    var ox=rect.right-stageRect.left-rect.width*.14;
    var oy=rect.top-stageRect.top+rect.height*.27;
    var count=window.innerWidth<700?5:8;
    for(var i=0;i<count;i++){
      particles.push({
        x:ox+(Math.random()*6-3),
        y:oy+(Math.random()*8-4),
        vx:(1.35+Math.random()*1.9)*(window.innerWidth<700?.88:1),
        vy:(Math.random()-.5)*.7,
        life:1,
        r:.7+Math.random()*2.7,
        z:Math.random(),
        drift:Math.random()*Math.PI*2
      });
    }
    if(particles.length>250)particles.splice(0,particles.length-250);
  }

  function drawMist(ts){
    if(!ctx||!mistActive){mistRaf=0;return}
    var rect=stage.getBoundingClientRect();
    var w=rect.width,h=rect.height;
    var dt=Math.min(32,ts-(lastTime||ts))/16.67;
    lastTime=ts;
    ctx.clearRect(0,0,w,h);
    spawnMist(w,h);

    for(var i=particles.length-1;i>=0;i--){
      var p=particles[i];
      p.x+=p.vx*dt*(1+p.z*.6);
      p.y+=p.vy*dt+Math.sin(p.drift+p.x*.02)*.14;
      p.vx*=1.003;
      p.life-=.012*dt*(.8+p.z*.45);
      p.r+=.018*dt;
      if(p.life<=0||p.x>w+30){particles.splice(i,1);continue}

      var a=Math.max(0,p.life)*(.08+.15*p.z);
      var grad=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*4);
      grad.addColorStop(0,'rgba(255,255,255,'+a+')');
      grad.addColorStop(.4,'rgba(232,207,194,'+(a*.55)+')');
      grad.addColorStop(1,'rgba(232,207,194,0)');
      ctx.fillStyle=grad;
      ctx.beginPath();
      ctx.arc(p.x,p.y,p.r*4,0,Math.PI*2);
      ctx.fill();
    }
    mistRaf=requestAnimationFrame(drawMist);
  }
  function startMist(){
    if(!ctx||mistRaf||reduce)return;
    resizeMist();
    mistRaf=requestAnimationFrame(drawMist);
  }
  function stopMist(){
    mistActive=false;
    if(mistRaf){cancelAnimationFrame(mistRaf);mistRaf=0}
    if(ctx){
      var rect=stage.getBoundingClientRect();
      ctx.clearRect(0,0,rect.width,rect.height);
    }
    particles=[];
  }
  window.addEventListener('resize',resizeMist,{passive:true});

  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(){
      var id=a.getAttribute('href');
      var target=id&&document.querySelector(id);
      if(!target)return;
      setTimeout(function(){target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'})},0);
    });
  });

  render();
  resizeMist();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1451"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function smooth(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function lerp(a,b,t){return a+(b-a)*t}
  function fadeWindow(p,start,end){
    var edge=Math.min(.05,(end-start)*.28);
    if(p<start||p>end)return 0;
    if(p<start+edge)return smooth((p-start)/edge);
    if(p>end-edge)return smooth((end-p)/edge);
    return 1;
  }
  function interpolate(p,keys){
    if(p<=keys[0][0])return keys[0].slice(1);
    for(var i=0;i<keys.length-1;i++){
      var a=keys[i],b=keys[i+1];
      if(p>=a[0]&&p<=b[0]){
        var t=smooth((p-a[0])/(b[0]-a[0])),out=[];
        for(var j=1;j<a.length;j++)out.push(lerp(a[j],b[j],t));
        return out;
      }
    }
    return keys[keys.length-1].slice(1);
  }

  function init(root){
    if(!root||root.dataset.msxInit==='1')return;
    root.dataset.msxInit='1';
    root.classList.add('js-ready');

    var nav=root.querySelector('[data-nav]');
    var pageBar=root.querySelector('[data-page-progress]');
    var loader=root.querySelector('[data-loader]');
    var loaderBar=root.querySelector('[data-loader-bar]');
    var hero=root.querySelector('[data-story]');
    var heroScene=root.querySelector('[data-product-scene]');
    var heroProduct=root.querySelector('[data-product-img]');
    var heroModals=[].slice.call(root.querySelectorAll('.msx-modal'));
    var heroDots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var ritual=root.querySelector('[data-ritual-story]');
    var ritualStage=root.querySelector('[data-ritual-stage]');
    var ritualProduct=ritualStage&&ritualStage.querySelector('.msx-ritual-product img');
    var ritualSteps=[].slice.call(root.querySelectorAll('[data-rstep]'));
    var ritualDots=ritualStage?[].slice.call(ritualStage.querySelectorAll('.msx-ritual-dots i')):[];
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var heroCurrent=0,heroTarget=0,ritualCurrent=0,ritualTarget=0,ticking=false;

    var heroKeys=[
      [0,.70,.50,.98],
      [.18,.66,.50,1.04],
      [.39,.34,.50,1.02],
      [.60,.68,.50,1.05],
      [.80,.35,.50,1.00],
      [1,.50,.49,.96]
    ];

    function sectionProgress(el){
      if(!el)return 0;
      var r=el.getBoundingClientRect();
      var scrollable=el.offsetHeight-window.innerHeight;
      if(scrollable<=0)return 0;
      return clamp(-r.top/scrollable,0,1);
    }

    function heroIndex(p){
      var centers=[.08,.31,.56,.79,.95],best=0,d=99;
      centers.forEach(function(c,i){var n=Math.abs(p-c);if(n<d){d=n;best=i}});
      return best;
    }

    function renderHero(p){
      if(!hero)return;
      var mobile=window.innerWidth<=720;
      var v=interpolate(p,heroKeys);
      var x=mobile?50:v[0]*100,y=mobile?42:v[1]*100,scale=mobile?1:v[2];
      if(heroScene)heroScene.style.transform='translate3d('+(x-50)+'vw,'+(y-50)+'vh,0) scale('+scale+')';

      var orbit=p*350;
      var o1=root.querySelector('.msx-story .msx-orbit--one');
      var o2=root.querySelector('.msx-story .msx-orbit--two');
      var d1=root.querySelector('.msx-orbit-dot--one');
      var d2=root.querySelector('.msx-orbit-dot--two');
      if(o1)o1.style.transform='translate(-50%,-50%) rotate('+orbit+'deg)';
      if(o2)o2.style.transform='translate(-50%,-50%) rotate('+(-orbit*1.22+70)+'deg)';
      if(d1)d1.style.transform='rotate('+orbit+'deg) translateY(-310px) rotate('+(-orbit)+'deg)';
      if(d2)d2.style.transform='rotate('+(-orbit*1.22+70)+'deg) translateY(-215px) rotate('+(orbit*1.22-70)+'deg)';

      heroModals.forEach(function(el){
        var start=parseFloat(el.dataset.start),end=parseFloat(el.dataset.end),side=el.dataset.side,o=fadeWindow(p,start,end);
        el.style.opacity=o.toFixed(3);
        el.style.pointerEvents=o>.75?'auto':'none';
        if(mobile)el.style.transform='translateY('+(16*(1-o))+'px) scale('+(0.985+.015*o)+')';
        else if(side==='center')el.style.transform='translate(-50%,-50%) scale('+(0.94+.06*o)+')';
        else el.style.transform='translateY(-50%) translateX('+((side==='left'?-58:58)*(1-o))+'px)';
      });
      var ai=heroIndex(p);
      heroDots.forEach(function(dot,i){dot.classList.toggle('is-active',i===ai)});
      var cue=root.querySelector('.msx-scroll-cue');if(cue)cue.style.opacity=p<.055?'1':'0';
    }

    function renderRitual(p){
      if(!ritualStage)return;
      var centers=[.10,.50,.90];
      ritualSteps.forEach(function(step,i){
        var d=Math.abs(p-centers[i]);
        var o=clamp(1-d/.24,0,1);o=smooth(o);
        step.style.opacity=o.toFixed(3);
        step.style.transform='translateY('+(24*(1-o))+'px)';
        step.style.pointerEvents=o>.75?'auto':'none';
      });
      var phase=p<.33?0:(p<.67?1:2);
      ritualDots.forEach(function(dot,i){dot.classList.toggle('is-active',i===phase)});
      if(ritualProduct){
        var shift=phase===0?-8:phase===1?3:10;
        var scale=phase===1?1.035:phase===2?1.01:1;
        ritualProduct.style.transform='translateY('+shift+'px) scale('+scale+')';
      }
    }

    function updateNav(){
      var y=window.scrollY||document.documentElement.scrollTop||0;
      var max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
      if(pageBar)pageBar.style.width=(clamp(y/max,0,1)*100)+'%';
      if(nav)nav.classList.toggle('is-scrolled',y>20);
      if(nav){
        var probeY=Math.min(window.innerHeight-1,nav.offsetHeight+8);
        var el=document.elementFromPoint(Math.max(10,Math.min(window.innerWidth-10,window.innerWidth*.5)),probeY);
        var toneEl=el&&el.closest?el.closest('[data-tone]'):null;
        nav.classList.toggle('is-light',!!(toneEl&&toneEl.getAttribute('data-tone')==='light'));
      }
    }

    function tick(){
      heroCurrent+= (heroTarget-heroCurrent)*.15;
      ritualCurrent+= (ritualTarget-ritualCurrent)*.15;
      if(Math.abs(heroCurrent-heroTarget)<.001)heroCurrent=heroTarget;
      if(Math.abs(ritualCurrent-ritualTarget)<.001)ritualCurrent=ritualTarget;
      renderHero(heroCurrent);renderRitual(ritualCurrent);
      if(Math.abs(heroCurrent-heroTarget)>.001||Math.abs(ritualCurrent-ritualTarget)>.001)requestAnimationFrame(tick);
      else ticking=false;
    }

    function onScroll(){
      heroTarget=sectionProgress(hero);
      ritualTarget=sectionProgress(ritual);
      updateNav();
      if(reduced){heroCurrent=heroTarget;ritualCurrent=ritualTarget;renderHero(heroCurrent);renderRitual(ritualCurrent);return}
      if(!ticking){ticking=true;requestAnimationFrame(tick)}
    }

    function hideLoader(){
      if(loaderBar)loaderBar.style.width='100%';
      setTimeout(function(){if(loader)loader.classList.add('is-hidden')},150);
    }
    if(heroProduct&&heroProduct.complete&&heroProduct.naturalWidth)hideLoader();
    else if(heroProduct){
      if(loaderBar)loaderBar.style.width='58%';
      heroProduct.addEventListener('load',hideLoader,{once:true});
      heroProduct.addEventListener('error',hideLoader,{once:true});
      setTimeout(hideLoader,1600);
    }else hideLoader();

    var reveal=[].slice.call(root.querySelectorAll('.msx-fade,[data-draw]'));
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            if(entry.target.hasAttribute('data-draw'))entry.target.classList.add('is-drawn');
            observer.unobserve(entry.target);
          }
        });
      },{threshold:.11,rootMargin:'0px 0px -5% 0px'});
      reveal.forEach(function(el){observer.observe(el)});
    }else reveal.forEach(function(el){el.classList.add('is-visible','is-drawn')});

    root.querySelectorAll('.msx-nav a[href^="#"],.msx-discover[href^="#"]').forEach(function(link){
      link.addEventListener('click',function(e){
        var t=document.querySelector(link.getAttribute('href'));
        if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})}
      });
    });

    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',function(){heroTarget=sectionProgress(hero);ritualTarget=sectionProgress(ritual);heroCurrent=heroTarget;ritualCurrent=ritualTarget;renderHero(heroCurrent);renderRitual(ritualCurrent);updateNav()},{passive:true});
    heroTarget=sectionProgress(hero);ritualTarget=sectionProgress(ritual);heroCurrent=heroTarget;ritualCurrent=ritualTarget;renderHero(heroCurrent);renderRitual(ritualCurrent);updateNav();
  }

  function initAll(scope){(scope||document).querySelectorAll('[data-msx]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});
  else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1455"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function smooth(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function lerp(a,b,t){return a+(b-a)*t}
  function fadeWindow(p,start,end){
    var edge=Math.min(.05,(end-start)*.28);
    if(p<start||p>end)return 0;
    if(p<start+edge)return smooth((p-start)/edge);
    if(p>end-edge)return smooth((end-p)/edge);
    return 1;
  }
  function interpolate(p,keys){
    if(p<=keys[0][0])return keys[0].slice(1);
    for(var i=0;i<keys.length-1;i++){
      var a=keys[i],b=keys[i+1];
      if(p>=a[0]&&p<=b[0]){
        var t=smooth((p-a[0])/(b[0]-a[0])),out=[];
        for(var j=1;j<a.length;j++)out.push(lerp(a[j],b[j],t));
        return out;
      }
    }
    return keys[keys.length-1].slice(1);
  }

  function init(root){
    if(!root||root.dataset.msxInit==='1')return;
    root.dataset.msxInit='1';
    root.classList.add('js-ready');

    var nav=root.querySelector('[data-nav]');
    var pageBar=root.querySelector('[data-page-progress]');
    var loader=root.querySelector('[data-loader]');
    var loaderBar=root.querySelector('[data-loader-bar]');
    var hero=root.querySelector('[data-story]');
    var heroScene=root.querySelector('[data-product-scene]');
    var heroProduct=root.querySelector('[data-product-img]');
    var heroModals=[].slice.call(root.querySelectorAll('.msx-modal'));
    var heroDots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var ritual=root.querySelector('[data-ritual-story]');
    var ritualStage=root.querySelector('[data-ritual-stage]');
    var ritualProduct=ritualStage&&ritualStage.querySelector('.msx-ritual-product img');
    var ritualSteps=[].slice.call(root.querySelectorAll('[data-rstep]'));
    var ritualDots=ritualStage?[].slice.call(ritualStage.querySelectorAll('.msx-ritual-dots i')):[];
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var heroCurrent=0,heroTarget=0,ritualCurrent=0,ritualTarget=0,ticking=false;

    var heroKeys=[
      [0,.70,.50,.98],
      [.18,.66,.50,1.04],
      [.39,.34,.50,1.02],
      [.60,.68,.50,1.05],
      [.80,.35,.50,1.00],
      [1,.50,.49,.96]
    ];

    function sectionProgress(el){
      if(!el)return 0;
      var r=el.getBoundingClientRect();
      var scrollable=el.offsetHeight-window.innerHeight;
      if(scrollable<=0)return 0;
      return clamp(-r.top/scrollable,0,1);
    }

    function heroIndex(p){
      var centers=[.08,.31,.56,.79,.95],best=0,d=99;
      centers.forEach(function(c,i){var n=Math.abs(p-c);if(n<d){d=n;best=i}});
      return best;
    }

    function renderHero(p){
      if(!hero)return;
      var mobile=window.innerWidth<=720;
      var v=interpolate(p,heroKeys);
      var x=mobile?50:v[0]*100,y=mobile?42:v[1]*100,scale=mobile?1:v[2];
      if(heroScene)heroScene.style.transform='translate3d('+(x-50)+'vw,'+(y-50)+'vh,0) scale('+scale+')';

      var orbit=p*350;
      var o1=root.querySelector('.msx-story .msx-orbit--one');
      var o2=root.querySelector('.msx-story .msx-orbit--two');
      var d1=root.querySelector('.msx-orbit-dot--one');
      var d2=root.querySelector('.msx-orbit-dot--two');
      if(o1)o1.style.transform='translate(-50%,-50%) rotate('+orbit+'deg)';
      if(o2)o2.style.transform='translate(-50%,-50%) rotate('+(-orbit*1.22+70)+'deg)';
      if(d1)d1.style.transform='rotate('+orbit+'deg) translateY(-310px) rotate('+(-orbit)+'deg)';
      if(d2)d2.style.transform='rotate('+(-orbit*1.22+70)+'deg) translateY(-215px) rotate('+(orbit*1.22-70)+'deg)';

      heroModals.forEach(function(el){
        var start=parseFloat(el.dataset.start),end=parseFloat(el.dataset.end),side=el.dataset.side,o=fadeWindow(p,start,end);
        el.style.opacity=o.toFixed(3);
        el.style.pointerEvents=o>.75?'auto':'none';
        if(mobile)el.style.transform='translateY('+(16*(1-o))+'px) scale('+(0.985+.015*o)+')';
        else if(side==='center')el.style.transform='translate(-50%,-50%) scale('+(0.94+.06*o)+')';
        else el.style.transform='translateY(-50%) translateX('+((side==='left'?-58:58)*(1-o))+'px)';
      });
      var ai=heroIndex(p);
      heroDots.forEach(function(dot,i){dot.classList.toggle('is-active',i===ai)});
      var cue=root.querySelector('.msx-scroll-cue');if(cue)cue.style.opacity=p<.055?'1':'0';
    }

    function renderRitual(p){
      if(!ritualStage)return;
      var centers=[.06,.50,.94];
      ritualSteps.forEach(function(step,i){
        var d=Math.abs(p-centers[i]);
        var o=clamp(1-d/.24,0,1);o=smooth(o);
        step.style.opacity=o.toFixed(3);
        step.style.transform='translateY('+(24*(1-o))+'px)';
        step.style.pointerEvents=o>.75?'auto':'none';
      });
      var phase=p<.33?0:(p<.67?1:2);
      ritualDots.forEach(function(dot,i){dot.classList.toggle('is-active',i===phase)});
      if(ritualProduct){
        var shift=phase===0?-8:phase===1?3:10;
        var scale=phase===1?1.035:phase===2?1.01:1;
        ritualProduct.style.transform='translateY('+shift+'px) scale('+scale+')';
      }
    }

    function updateNav(){
      var y=window.scrollY||document.documentElement.scrollTop||0;
      var max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
      if(pageBar)pageBar.style.width=(clamp(y/max,0,1)*100)+'%';
      if(nav)nav.classList.toggle('is-scrolled',y>20);
      if(nav){
        var probeY=nav.offsetHeight+10;
        var sections=[].slice.call(root.querySelectorAll('[data-tone]'));
        var tone='dark';
        for(var i=0;i<sections.length;i++){
          var r=sections[i].getBoundingClientRect();
          if(r.top<=probeY&&r.bottom>probeY){
            tone=sections[i].getAttribute('data-tone')||'dark';
            break;
          }
        }
        nav.classList.toggle('is-light',tone==='light');
      }
    }

    function tick(){
      heroCurrent+= (heroTarget-heroCurrent)*.15;
      ritualCurrent+= (ritualTarget-ritualCurrent)*.15;
      if(Math.abs(heroCurrent-heroTarget)<.001)heroCurrent=heroTarget;
      if(Math.abs(ritualCurrent-ritualTarget)<.001)ritualCurrent=ritualTarget;
      renderHero(heroCurrent);renderRitual(ritualCurrent);
      if(Math.abs(heroCurrent-heroTarget)>.001||Math.abs(ritualCurrent-ritualTarget)>.001)requestAnimationFrame(tick);
      else ticking=false;
    }

    function onScroll(){
      heroTarget=sectionProgress(hero);
      ritualTarget=sectionProgress(ritual);
      updateNav();
      if(reduced){heroCurrent=heroTarget;ritualCurrent=ritualTarget;renderHero(heroCurrent);renderRitual(ritualCurrent);return}
      if(!ticking){ticking=true;requestAnimationFrame(tick)}
    }

    function hideLoader(){
      if(loaderBar)loaderBar.style.width='100%';
      setTimeout(function(){if(loader)loader.classList.add('is-hidden')},150);
    }
    if(heroProduct&&heroProduct.complete&&heroProduct.naturalWidth)hideLoader();
    else if(heroProduct){
      if(loaderBar)loaderBar.style.width='58%';
      heroProduct.addEventListener('load',hideLoader,{once:true});
      heroProduct.addEventListener('error',hideLoader,{once:true});
      setTimeout(hideLoader,1600);
    }else hideLoader();

    var reveal=[].slice.call(root.querySelectorAll('.msx-fade,[data-draw]'));
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            if(entry.target.hasAttribute('data-draw'))entry.target.classList.add('is-drawn');
            observer.unobserve(entry.target);
          }
        });
      },{threshold:.11,rootMargin:'0px 0px -5% 0px'});
      reveal.forEach(function(el){observer.observe(el)});
    }else reveal.forEach(function(el){el.classList.add('is-visible','is-drawn')});

    root.querySelectorAll('.msx-nav a[href^="#"],.msx-discover[href^="#"]').forEach(function(link){
      link.addEventListener('click',function(e){
        var t=document.querySelector(link.getAttribute('href'));
        if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})}
      });
    });

    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',function(){heroTarget=sectionProgress(hero);ritualTarget=sectionProgress(ritual);heroCurrent=heroTarget;ritualCurrent=ritualTarget;renderHero(heroCurrent);renderRitual(ritualCurrent);updateNav()},{passive:true});
    heroTarget=sectionProgress(hero);ritualTarget=sectionProgress(ritual);heroCurrent=heroTarget;ritualCurrent=ritualTarget;renderHero(heroCurrent);renderRitual(ritualCurrent);updateNav();
  }

  function initAll(scope){(scope||document).querySelectorAll('[data-msx]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});
  else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1504"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function lerp(a,b,t){return a+(b-a)*t}
  function pulse(p,c,w){return ease(1-clamp(Math.abs(p-c)/w,0,1))}
  function mix(p,keys){
    if(p<=keys[0][0])return keys[0].slice(1);
    for(var i=0;i<keys.length-1;i++){var a=keys[i],b=keys[i+1];if(p>=a[0]&&p<=b[0]){var t=ease((p-a[0])/(b[0]-a[0])),o=[];for(var j=1;j<a.length;j++)o.push(lerp(a[j],b[j],t));return o}}
    return keys[keys.length-1].slice(1)
  }
  function init(root){
    if(!root||root.dataset.ready)return;root.dataset.ready="1";
    var story=root.querySelector("[data-story]"),product=root.querySelector("[data-product]"),img=root.querySelector("[data-product-img]"),shadow=root.querySelector("[data-shadow]"),halo=root.querySelector("[data-halo]"),o1=root.querySelector("[data-orbit-one]"),o2=root.querySelector("[data-orbit-two]"),d1=root.querySelector("[data-dot-one]"),d2=root.querySelector("[data-dot-two]"),cream=root.querySelector("[data-bg-cream]"),chap=[].slice.call(root.querySelectorAll("[data-chapter]")),steps=[].slice.call(root.querySelectorAll("[data-steps] span")),callouts=root.querySelector("[data-callouts]"),cap=root.querySelector("[data-focus-cap]"),label=root.querySelector("[data-focus-label]"),sig=root.querySelector("[data-signature-art]"),sigPaths=[].slice.call(root.querySelectorAll(".mtx-signature-art path,.mtx-signature-art circle")),spray=root.querySelector("[data-spray]"),breath=root.querySelector("[data-breath]"),rings=[].slice.call(root.querySelectorAll("[data-breath] i")),bar=root.querySelector("[data-progress]"),nav=root.querySelector("[data-nav]"),loader=root.querySelector("[data-loader]"),loaderBar=root.querySelector("[data-loader-bar]"),cue=root.querySelector("[data-scrollcue]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches,current=0,target=0,ticking=false;
    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(pageWrapper&&/auto|scroll/.test(getComputedStyle(pageWrapper).overflowY))?pageWrapper:window;
    var centers=[.035,.145,.245,.355,.465,.585,.690,.795,.895,.975];
    var keys=[[0,.67,.51,1],[.14,.62,.50,1.07],[.25,.53,.50,1.18],[.36,.70,.50,.82],[.47,.68,.50,.72],[.58,.38,.50,.94],[.69,.39,.50,.94],[.80,.39,.50,.94],[.90,.69,.50,1.02],[1,.69,.50,.88]];
    function viewportH(){return scroller===window?window.innerHeight:scroller.clientHeight}
    function prog(){
      var r=story.getBoundingClientRect(),base=scroller===window?0:scroller.getBoundingClientRect().top,len=story.offsetHeight-viewportH();
      return len>0?clamp(-(r.top-base)/len,0,1):0
    }
    function nearest(p){var k=0,z=9;centers.forEach(function(c,i){var n=Math.abs(c-p);if(n<z){z=n;k=i}});return k}
    function show(el,o,s){if(!el)return;el.style.opacity=o.toFixed(3);el.style.transform="translate(-50%,-50%) scale("+(s||1)+")"}
    function render(p){
      var mobile=window.innerWidth<=720,idx=nearest(p),v=mix(p,keys),x=mobile?50:v[0]*100,y=mobile?(idx>=5&&idx<=7?34:37):v[1]*100,s=mobile?Math.min(v[2],1):v[2];
      product.style.left=x+"%";product.style.top=y+"%";product.style.transform="translate(-50%,-50%) scale("+s+")";product.style.opacity=(idx===3||idx===4)?.14:1;
      shadow.style.transform="translateX(-50%) scaleX("+(1+.14*Math.sin(p*15))+")";
      var light=Math.max(pulse(p,.245,.12),pulse(p,.355,.13));cream.style.opacity=(.98*light).toFixed(3);
      var hx=mobile?50:(idx>=5&&idx<=7?39:idx===3||idx===4?68:67),hy=mobile?36:50;[halo,o1,o2,d1,d2].forEach(function(e){e.style.left=hx+"%";e.style.top=hy+"%"});
      var rot=p*420;o1.style.transform="translate(-50%,-50%) rotate("+rot+"deg)";o2.style.transform="translate(-50%,-50%) rotate("+(-rot*.82)+"deg)";d1.style.transform="rotate("+rot+"deg) translateY("+(-Math.min(280,window.innerWidth*.18))+"px)";d2.style.transform="rotate("+(-rot*.82)+"deg) translateY("+(-Math.min(195,window.innerWidth*.13))+"px)";halo.style.transform="translate(-50%,-50%) scale("+(1+.07*Math.sin(p*18))+")";
      chap.forEach(function(el,i){var q=pulse(p,centers[i],i===9?.055:.065);el.style.opacity=q.toFixed(3);el.style.transform=mobile?"translateY("+(18*(1-q))+"px)":"translateY(calc(-50% + "+(28*(1-q))+"px))";el.style.pointerEvents=q>.7?"auto":"none"});
      steps.forEach(function(e,i){e.classList.toggle("is-active",i===idx)});
      var co=pulse(p,.335,.055),lo=pulse(p,.385,.055);show(cap,co,.95+.05*co);show(label,lo,.95+.05*lo);callouts.style.opacity=(pulse(p,.355,.075)*.95).toFixed(3);
      var so=pulse(p,.465,.08);sig.style.opacity=so.toFixed(3);sig.style.transform="translate(-50%,-50%) scale("+(0.95+.05*so)+")";sigPaths.forEach(function(path,i){var draw=clamp((so*1.3)-(i%3)*.08,0,1);path.style.strokeDashoffset=(1000*(1-draw)).toFixed(0)});
      var sp=pulse(p,.690,.065);spray.style.opacity=sp.toFixed(3);[].slice.call(spray.querySelectorAll("i")).forEach(function(e,i){e.style.transform="translate("+(sp*(18+i*4))+"px,"+(-sp*(i%2?10:3))+"px)";e.style.opacity=(sp*(1-i*.05)).toFixed(2)});
      var br=pulse(p,.795,.07);breath.style.opacity=br.toFixed(3);rings.forEach(function(e,i){e.style.transform="translate(-50%,-50%) scale("+(0.80+br*(.18+i*.08))+")";e.style.opacity=(br*(.9-i*.18)).toFixed(2)});
      cue.style.opacity=p<.035?"1":"0";bar.style.width=(p*100)+"%";
      var isLight=light>.52;nav.style.color=isLight?"#2A1D18":"#FAF7F2";nav.style.background=isLight?"rgba(250,247,242,.86)":"rgba(9,5,4,.52)";nav.style.borderBottomColor=isLight?"rgba(42,29,24,.08)":"rgba(255,255,255,.07)";
    }
    function tick(){current+=(target-current)*.16;if(Math.abs(current-target)<.0007)current=target;render(current);if(Math.abs(current-target)>.0007)requestAnimationFrame(tick);else ticking=false}
    function onScroll(){target=prog();if(reduced){current=target;render(current);return}if(!ticking){ticking=true;requestAnimationFrame(tick)}}
    function jump(p){
      var r=story.getBoundingClientRect(),len=story.offsetHeight-viewportH(),dest;
      if(scroller===window){
        dest=(window.scrollY||document.documentElement.scrollTop)+r.top+len*clamp(p,0,1);
        window.scrollTo({top:dest,behavior:"smooth"})
      }else{
        var sr=scroller.getBoundingClientRect();
        dest=scroller.scrollTop+(r.top-sr.top)+len*clamp(p,0,1);
        scroller.scrollTo({top:dest,behavior:"smooth"})
      }
    }
    root.querySelectorAll("[data-jump]").forEach(function(b){b.addEventListener("click",function(){jump(parseFloat(b.dataset.jump)||0)})});
    scroller.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){target=prog();current=target;render(current)},{passive:true});
    function done(){loaderBar.style.width="100%";setTimeout(function(){loader.classList.add("is-hidden")},140)}
    if(img&&img.complete&&img.naturalWidth)done();else{loaderBar.style.width="55%";img.addEventListener("load",done,{once:true});img.addEventListener("error",done,{once:true});setTimeout(done,1800)}
    target=prog();current=target;render(current)
  }
  function start(scope){(scope||document).querySelectorAll("[data-mtx]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){start(document)});else start(document);
  document.addEventListener("shopify:section:load",function(e){start(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1510"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(pageWrapper&&/auto|scroll/.test(getComputedStyle(pageWrapper).overflowY))?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var active=0;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var frames=[
      {x:68,y:51,s:1.00},
      {x:69,y:49,s:1.08},
      {x:35,y:50,s:1.15},
      {x:69,y:50,s:.92},
      {x:67,y:50,s:.78},
      {x:36,y:49,s:1.00},
      {x:69,y:48,s:1.00},
      {x:36,y:49,s:1.00},
      {x:69,y:50,s:1.05},
      {x:69,y:48,s:.88}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop
    }
    function viewportH(){return scroller===window?window.innerHeight:scroller.clientHeight}
    function containerTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top)
    }
    function storyProgress(){
      var top=containerTop(), len=Math.max(1,story.scrollHeight-viewportH());
      return clamp((scrollTop()-top)/len,0,1)
    }
    function activeFromViewport(){
      var vh=viewportH(), base=scroller===window?0:scroller.getBoundingClientRect().top;
      var best=0,bestDist=1e9;
      steps.forEach(function(step,i){
        var r=step.getBoundingClientRect();
        var center=(r.top-base)+(r.height*.5);
        var d=Math.abs(center-vh*.52);
        if(d<bestDist){bestDist=d;best=i}
      });
      return best
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i&&root.classList.contains("is-initialized"))return;
      active=i;
      root.classList.add("is-initialized");
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,3,5,7,9].indexOf(i)>-1);
      root.classList.toggle("is-detail-cap",i===3);
      root.classList.toggle("is-detail-label",i===3);
      root.classList.toggle("is-signature",i===4);
      root.classList.toggle("is-prepare",i===5);
      root.classList.toggle("is-spray",i===6);
      root.classList.toggle("is-breath",i===7);
    }
    function stageRender(p){
      var n=steps.length-1;
      var exact=p*n;
      var a=Math.floor(exact),b=Math.min(n,a+1),t=ease(exact-a);
      var fa=frames[a],fb=frames[b];
      var mobile=window.innerWidth<=720;
      if(!mobile){
        var x=lerp(fa.x,fb.x,t),y=lerp(fa.y,fb.y,t),s=lerp(fa.s,fb.s,t);
        product.style.left=x+"%";
        product.style.top=y+"%";
        product.style.transform="translate(-50%,-50%) scale("+s+")";
        halo.style.left=x+"%";halo.style.top=y+"%";
        orbitOne.style.left=x+"%";orbitOne.style.top=y+"%";
        orbitTwo.style.left=x+"%";orbitTwo.style.top=y+"%";
        dotOne.style.left=x+"%";dotOne.style.top=y+"%";
        dotTwo.style.left=x+"%";dotTwo.style.top=y+"%";
      }
      var rot=p*430;
      orbitOne.style.transform="translate(-50%,-50%) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate(-50%,-50%) rotate("+(-rot*.84)+"deg)";
      var r1=Math.min(290,window.innerWidth*(mobile?.36:.18));
      var r2=Math.min(205,window.innerWidth*(mobile?.24:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.84)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100)+"%";
    }
    function tick(){
      currentP+= (targetP-currentP)*.14;
      if(Math.abs(targetP-currentP)<.0006)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0006){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=storyProgress();
      setActive(activeFromViewport());
      if(reduced){currentP=targetP;stageRender(currentP);return}
      if(!raf)raf=requestAnimationFrame(tick)
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:"smooth"})
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:"smooth"})
      }
    }
    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)})
    });
    scroller.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){targetP=storyProgress();currentP=targetP;setActive(activeFromViewport());stageRender(currentP)},{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120)
    }
    loaderBar.style.width="58%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700)
    }else done();

    setActive(activeFromViewport());
    targetP=storyProgress();
    currentP=targetP;
    stageRender(currentP);
  }
  function start(scope){(scope||document).querySelectorAll("[data-mtx]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){start(document)});
  else start(document);
  document.addEventListener("shopify:section:load",function(e){start(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1522"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(pageWrapper&&/auto|scroll/.test(getComputedStyle(pageWrapper).overflowY))?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var active=0;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var frames=[
      {x:68,y:51,s:1.00},
      {x:68,y:49,s:1.08},
      {x:35,y:50,s:1.15},
      {x:69,y:50,s:.88},
      {x:33,y:50,s:.88},
      {x:68,y:50,s:.78},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:69,y:50,s:1.05},
      {x:82,y:48,s:.72}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop
    }
    function viewportH(){return scroller===window?window.innerHeight:scroller.clientHeight}
    function containerTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top)
    }
    function storyProgress(){
      var top=containerTop(), len=Math.max(1,story.scrollHeight-viewportH());
      return clamp((scrollTop()-top)/len,0,1)
    }
    function activeFromViewport(){
      var vh=viewportH(), base=scroller===window?0:scroller.getBoundingClientRect().top;
      var best=0,bestDist=1e9;
      steps.forEach(function(step,i){
        var r=step.getBoundingClientRect();
        var center=(r.top-base)+(r.height*.5);
        var d=Math.abs(center-vh*.52);
        if(d<bestDist){bestDist=d;best=i}
      });
      return best
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i&&root.classList.contains("is-initialized"))return;
      active=i;
      root.classList.add("is-initialized");
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-detail-cap",i===3);
      root.classList.toggle("is-detail-label",i===4);
      root.classList.toggle("is-signature",i===5);
      root.classList.toggle("is-prepare",i===6);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      root.classList.toggle("is-facts",i===10);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var n=steps.length-1;
      var exact=p*n;
      var a=Math.floor(exact),b=Math.min(n,a+1),t=ease(exact-a);
      var fa=frames[a],fb=frames[b];
      var mobile=window.innerWidth<=720;
      if(!mobile){
        var x=lerp(fa.x,fb.x,t),y=lerp(fa.y,fb.y,t),s=lerp(fa.s,fb.s,t);
        product.style.left=x+"%";
        product.style.top=y+"%";
        product.style.transform="translate(-50%,-50%) scale("+s+")";
        halo.style.left=x+"%";halo.style.top=y+"%";
        orbitOne.style.left=x+"%";orbitOne.style.top=y+"%";
        orbitTwo.style.left=x+"%";orbitTwo.style.top=y+"%";
        dotOne.style.left=x+"%";dotOne.style.top=y+"%";
        dotTwo.style.left=x+"%";dotTwo.style.top=y+"%";
      }
      var rot=p*430;
      orbitOne.style.transform="translate(-50%,-50%) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate(-50%,-50%) rotate("+(-rot*.84)+"deg)";
      var r1=Math.min(290,window.innerWidth*(mobile?.36:.18));
      var r2=Math.min(205,window.innerWidth*(mobile?.24:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.84)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100)+"%";
    }
    function tick(){
      currentP+= (targetP-currentP)*.14;
      if(Math.abs(targetP-currentP)<.0006)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0006){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=storyProgress();
      setActive(activeFromViewport());
      if(reduced){currentP=targetP;stageRender(currentP);return}
      if(!raf)raf=requestAnimationFrame(tick)
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:"smooth"})
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:"smooth"})
      }
    }
    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)})
    });
    scroller.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){targetP=storyProgress();currentP=targetP;setActive(activeFromViewport());stageRender(currentP)},{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120)
    }
    loaderBar.style.width="58%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700)
    }else done();

    setActive(activeFromViewport());
    targetP=storyProgress();
    currentP=targetP;
    stageRender(currentP);
  }
  function start(scope){(scope||document).querySelectorAll("[data-mtx]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){start(document)});
  else start(document);
  document.addEventListener("shopify:section:load",function(e){start(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1615"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(pageWrapper&&/auto|scroll/.test(getComputedStyle(pageWrapper).overflowY))?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var active=0;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var frames=[
      {x:68,y:51,s:1.00},
      {x:68,y:49,s:1.08},
      {x:35,y:50,s:1.15},
      {x:69,y:50,s:.88},
      {x:33,y:50,s:.88},
      {x:68,y:50,s:.78},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:69,y:50,s:1.05},
      {x:82,y:48,s:.72}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop
    }
    function viewportH(){return scroller===window?window.innerHeight:scroller.clientHeight}
    function containerTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top)
    }
    function storyProgress(){
      var top=containerTop(), len=Math.max(1,story.scrollHeight-viewportH());
      return clamp((scrollTop()-top)/len,0,1)
    }
    function activeFromViewport(){
      var vh=viewportH(), base=scroller===window?0:scroller.getBoundingClientRect().top;
      var best=0,bestDist=1e9;
      steps.forEach(function(step,i){
        var r=step.getBoundingClientRect();
        var center=(r.top-base)+(r.height*.5);
        var d=Math.abs(center-vh*.52);
        if(d<bestDist){bestDist=d;best=i}
      });
      return best
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i&&root.classList.contains("is-initialized"))return;
      active=i;
      root.classList.add("is-initialized");
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-detail-cap",i===3);
      root.classList.toggle("is-detail-label",i===4);
      root.classList.toggle("is-signature",i===5);
      root.classList.toggle("is-prepare",i===6);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      root.classList.toggle("is-facts",i===10);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var n=steps.length-1;
      var exact=p*n;
      var a=Math.floor(exact),b=Math.min(n,a+1),t=ease(exact-a);
      var fa=frames[a],fb=frames[b];
      var mobile=window.innerWidth<=720;
      if(!mobile){
        var x=lerp(fa.x,fb.x,t),y=lerp(fa.y,fb.y,t),s=lerp(fa.s,fb.s,t);
        product.style.left=x+"%";
        product.style.top=y+"%";
        product.style.transform="translate(-50%,-50%) scale("+s+")";
        halo.style.left=x+"%";halo.style.top=y+"%";
        orbitOne.style.left=x+"%";orbitOne.style.top=y+"%";
        orbitTwo.style.left=x+"%";orbitTwo.style.top=y+"%";
        dotOne.style.left=x+"%";dotOne.style.top=y+"%";
        dotTwo.style.left=x+"%";dotTwo.style.top=y+"%";
      }
      var rot=p*430;
      orbitOne.style.transform="translate(-50%,-50%) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate(-50%,-50%) rotate("+(-rot*.84)+"deg)";
      var r1=Math.min(290,window.innerWidth*(mobile?.36:.18));
      var r2=Math.min(205,window.innerWidth*(mobile?.24:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.84)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100)+"%";
    }
    function tick(){
      currentP+= (targetP-currentP)*.14;
      if(Math.abs(targetP-currentP)<.0006)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0006){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=storyProgress();
      setActive(activeFromViewport());
      if(reduced){currentP=targetP;stageRender(currentP);return}
      if(!raf)raf=requestAnimationFrame(tick)
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:"smooth"})
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:"smooth"})
      }
    }
    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)})
    });
    scroller.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){targetP=storyProgress();currentP=targetP;setActive(activeFromViewport());stageRender(currentP)},{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120)
    }
    loaderBar.style.width="58%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700)
    }else done();

    setActive(activeFromViewport());
    targetP=storyProgress();
    currentP=targetP;
    stageRender(currentP);
  }
  function start(scope){(scope||document).querySelectorAll("[data-mtx]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){start(document)});
  else start(document);
  document.addEventListener("shopify:section:load",function(e){start(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1620"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(pageWrapper&&/auto|scroll/.test(getComputedStyle(pageWrapper).overflowY))?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var active=0;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var frames=[
      {x:68,y:51,s:1.00},
      {x:68,y:49,s:1.08},
      {x:35,y:50,s:1.15},
      {x:69,y:50,s:.88},
      {x:33,y:50,s:.88},
      {x:68,y:50,s:.78},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:69,y:50,s:1.05},
      {x:82,y:48,s:.72}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop
    }
    function viewportH(){return scroller===window?window.innerHeight:scroller.clientHeight}
    function containerTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top)
    }
    function storyProgress(){
      var top=containerTop(), len=Math.max(1,story.scrollHeight-viewportH());
      return clamp((scrollTop()-top)/len,0,1)
    }
    function activeFromViewport(){
      var vh=viewportH(), base=scroller===window?0:scroller.getBoundingClientRect().top;
      var best=0,bestDist=1e9;
      steps.forEach(function(step,i){
        var r=step.getBoundingClientRect();
        var center=(r.top-base)+(r.height*.5);
        var d=Math.abs(center-vh*.52);
        if(d<bestDist){bestDist=d;best=i}
      });
      return best
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i&&root.classList.contains("is-initialized"))return;
      active=i;
      root.classList.add("is-initialized");
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-detail-cap",i===3);
      root.classList.toggle("is-detail-label",i===4);
      root.classList.toggle("is-signature",i===5);
      root.classList.toggle("is-prepare",i===6);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      root.classList.toggle("is-facts",i===10);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var n=steps.length-1;
      var exact=p*n;
      var a=Math.floor(exact),b=Math.min(n,a+1),t=ease(exact-a);
      var fa=frames[a],fb=frames[b];
      var mobile=window.innerWidth<=720;
      if(!mobile){
        var x=lerp(fa.x,fb.x,t),y=lerp(fa.y,fb.y,t),s=lerp(fa.s,fb.s,t);
        product.style.left=x+"%";
        product.style.top=y+"%";
        product.style.transform="translate(-50%,-50%) scale("+s+")";
        halo.style.left=x+"%";halo.style.top=y+"%";
        orbitOne.style.left=x+"%";orbitOne.style.top=y+"%";
        orbitTwo.style.left=x+"%";orbitTwo.style.top=y+"%";
        dotOne.style.left=x+"%";dotOne.style.top=y+"%";
        dotTwo.style.left=x+"%";dotTwo.style.top=y+"%";
      }
      var rot=p*430;
      orbitOne.style.transform="translate(-50%,-50%) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate(-50%,-50%) rotate("+(-rot*.84)+"deg)";
      var r1=Math.min(290,window.innerWidth*(mobile?.36:.18));
      var r2=Math.min(205,window.innerWidth*(mobile?.24:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.84)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100)+"%";
    }
    function tick(){
      currentP+= (targetP-currentP)*.14;
      if(Math.abs(targetP-currentP)<.0006)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0006){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=storyProgress();
      setActive(activeFromViewport());
      if(reduced){currentP=targetP;stageRender(currentP);return}
      if(!raf)raf=requestAnimationFrame(tick)
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:"smooth"})
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:"smooth"})
      }
    }
    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)})
    });
    scroller.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){targetP=storyProgress();currentP=targetP;setActive(activeFromViewport());stageRender(currentP)},{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120)
    }
    loaderBar.style.width="58%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700)
    }else done();

    setActive(activeFromViewport());
    targetP=storyProgress();
    currentP=targetP;
    stageRender(currentP);
  }
  function start(scope){(scope||document).querySelectorAll("[data-mtx]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){start(document)});
  else start(document);
  document.addEventListener("shopify:section:load",function(e){start(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1624"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(pageWrapper&&/auto|scroll/.test(getComputedStyle(pageWrapper).overflowY))?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var active=0;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var frames=[
      {x:68,y:51,s:1.00},
      {x:68,y:49,s:1.08},
      {x:35,y:50,s:1.15},
      {x:69,y:50,s:.88},
      {x:33,y:50,s:.88},
      {x:68,y:50,s:.78},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:35,y:50,s:1.00},
      {x:69,y:50,s:1.05},
      {x:82,y:48,s:.72}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop
    }
    function viewportH(){return scroller===window?window.innerHeight:scroller.clientHeight}
    function containerTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top)
    }
    function storyProgress(){
      var top=containerTop(), len=Math.max(1,story.scrollHeight-viewportH());
      return clamp((scrollTop()-top)/len,0,1)
    }
    function activeFromViewport(){
      var vh=viewportH(), base=scroller===window?0:scroller.getBoundingClientRect().top;
      var best=0,bestDist=1e9;
      steps.forEach(function(step,i){
        var r=step.getBoundingClientRect();
        var center=(r.top-base)+(r.height*.5);
        var d=Math.abs(center-vh*.52);
        if(d<bestDist){bestDist=d;best=i}
      });
      return best
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i&&root.classList.contains("is-initialized"))return;
      active=i;
      root.classList.add("is-initialized");
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-detail-cap",i===3);
      root.classList.toggle("is-detail-label",i===4);
      root.classList.toggle("is-signature",i===5);
      root.classList.toggle("is-prepare",i===6);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      root.classList.toggle("is-facts",i===10);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var n=steps.length-1;
      var exact=p*n;
      var a=Math.floor(exact),b=Math.min(n,a+1),t=ease(exact-a);
      var fa=frames[a],fb=frames[b];
      var mobile=window.innerWidth<=720;
      if(!mobile){
        var x=lerp(fa.x,fb.x,t),y=lerp(fa.y,fb.y,t),s=lerp(fa.s,fb.s,t);
        product.style.left=x+"%";
        product.style.top=y+"%";
        product.style.transform="translate(-50%,-50%) scale("+s+")";
        halo.style.left=x+"%";halo.style.top=y+"%";
        orbitOne.style.left=x+"%";orbitOne.style.top=y+"%";
        orbitTwo.style.left=x+"%";orbitTwo.style.top=y+"%";
        dotOne.style.left=x+"%";dotOne.style.top=y+"%";
        dotTwo.style.left=x+"%";dotTwo.style.top=y+"%";
      }
      var rot=p*430;
      orbitOne.style.transform="translate(-50%,-50%) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate(-50%,-50%) rotate("+(-rot*.84)+"deg)";
      var r1=Math.min(290,window.innerWidth*(mobile?.36:.18));
      var r2=Math.min(205,window.innerWidth*(mobile?.24:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.84)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100)+"%";
    }
    function tick(){
      currentP+= (targetP-currentP)*.14;
      if(Math.abs(targetP-currentP)<.0006)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0006){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=storyProgress();
      setActive(activeFromViewport());
      if(reduced){currentP=targetP;stageRender(currentP);return}
      if(!raf)raf=requestAnimationFrame(tick)
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:"smooth"})
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:"smooth"})
      }
    }
    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)})
    });
    scroller.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){targetP=storyProgress();currentP=targetP;setActive(activeFromViewport());stageRender(currentP)},{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120)
    }
    loaderBar.style.width="58%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700)
    }else done();

    setActive(activeFromViewport());
    targetP=storyProgress();
    currentP=targetP;
    stageRender(currentP);
  }
  function start(scope){(scope||document).querySelectorAll("[data-mtx]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){start(document)});
  else start(document);
  document.addEventListener("shopify:section:load",function(e){start(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1636"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.mthInit==='true')return;
    root.dataset.mthInit='true';
    root.classList.add('js-ready');

    var nav=root.querySelector('[data-mth-nav]');
    var progress=root.querySelector('[data-progress]');
    var reveals=[].slice.call(root.querySelectorAll('.mth-reveal'));

    reveals.forEach(function(el){
      if(el.getBoundingClientRect().top<window.innerHeight*.96)el.classList.add('is-visible');
    });

    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },{threshold:.04,rootMargin:'0px 0px -3% 0px'});
      reveals.forEach(function(el){
        if(!el.classList.contains('is-visible'))observer.observe(el);
      });
    }else{
      reveals.forEach(function(el){el.classList.add('is-visible')});
    }

    if(window.matchMedia&&window.matchMedia('(pointer:fine)').matches){
      root.querySelectorAll('[data-tilt]').forEach(function(stage){
        stage.addEventListener('pointermove',function(e){
          var r=stage.getBoundingClientRect();
          var x=(e.clientX-r.left)/r.width-.5;
          var y=(e.clientY-r.top)/r.height-.5;
          stage.style.transform='perspective(1200px) rotateX('+(-y*1.8)+'deg) rotateY('+(x*2.4)+'deg)';
        });
        stage.addEventListener('pointerleave',function(){stage.style.transform='none'});
      });
    }

    var ticking=false;
    function update(){
      ticking=false;
      var y=window.scrollY||document.documentElement.scrollTop||0;
      var max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
      if(progress)progress.style.width=(Math.max(0,Math.min(1,y/max))*100)+'%';
      if(nav)nav.classList.toggle('is-scrolled',y>18);
    }
    function schedule(){
      if(ticking)return;
      ticking=true;
      requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
  }

  function initAll(scope){
    (scope||document).querySelectorAll('[data-mth]').forEach(init);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll(document)});
  }else{
    initAll(document);
  }
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-20260920-1644"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function smooth(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function lerp(a,b,t){return a+(b-a)*t}
  function fadeWindow(p,start,end){
    var edge=Math.min(.045,(end-start)*.28);
    if(p<start||p>end)return 0;
    if(p<start+edge)return smooth((p-start)/edge);
    if(p>end-edge)return smooth((end-p)/edge);
    return 1;
  }
  function interpolate(p,keys){
    if(p<=keys[0][0])return keys[0].slice(1);
    for(var i=0;i<keys.length-1;i++){
      var a=keys[i],b=keys[i+1];
      if(p>=a[0]&&p<=b[0]){
        var t=smooth((p-a[0])/(b[0]-a[0]));
        var out=[];
        for(var j=1;j<a.length;j++)out.push(lerp(a[j],b[j],t));
        return out;
      }
    }
    return keys[keys.length-1].slice(1);
  }

  function init(root){
    if(!root||root.dataset.msxInit==='1')return;
    root.dataset.msxInit='1';
    root.classList.add('js-ready');

    var story=root.querySelector('[data-story]');
    var scene=root.querySelector('[data-product-scene]');
    var product=root.querySelector('[data-product-img]');
    var modals=[].slice.call(root.querySelectorAll('.msx-modal'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var nav=root.querySelector('[data-nav]');
    var progressBar=root.querySelector('[data-page-progress]');
    var loader=root.querySelector('[data-loader]');
    var loaderBar=root.querySelector('[data-loader-bar]');
    var current=0,target=0,ticking=false,rafId=0;
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var keys=[
      [0,.70,.50,.94],
      [.18,.67,.50,1.03],
      [.38,.34,.50,1.02],
      [.58,.68,.50,1.04],
      [.78,.35,.50,.99],
      [1,.50,.49,.94]
    ];

    function progress(){
      if(!story)return 0;
      var r=story.getBoundingClientRect();
      var scrollable=story.offsetHeight-window.innerHeight;
      if(scrollable<=0)return 0;
      return clamp(-r.top/scrollable,0,1);
    }

    function activeIndex(p){
      var centers=[.09,.32,.56,.79,.95],best=0,d=99;
      centers.forEach(function(c,i){var n=Math.abs(p-c);if(n<d){d=n;best=i}});
      return best;
    }

    function render(p){
      if(!story)return;
      var mobile=window.innerWidth<=720;
      var v=interpolate(p,keys);
      var x=mobile?50:v[0]*100;
      var y=mobile?42:v[1]*100;
      var scale=mobile?lerp(.92,1.02,Math.sin(p*Math.PI)*.5+.5):v[2];
      if(scene)scene.style.transform='translate3d('+(x-50)+'vw,'+(y-50)+'vh,0) scale('+scale+')';

      var orbit=p*360;
      var o1=root.querySelector('.msx-story .msx-orbit--one');
      var o2=root.querySelector('.msx-story .msx-orbit--two');
      var d1=root.querySelector('.msx-orbit-dot--one');
      var d2=root.querySelector('.msx-orbit-dot--two');
      if(o1)o1.style.transform='translate(-50%,-50%) rotate('+orbit+'deg)';
      if(o2)o2.style.transform='translate(-50%,-50%) rotate('+(-orbit*1.25+70)+'deg)';
      if(d1)d1.style.transform='rotate('+orbit+'deg) translateY(-310px) rotate('+(-orbit)+'deg)';
      if(d2)d2.style.transform='rotate('+(-orbit*1.25+70)+'deg) translateY(-215px) rotate('+(orbit*1.25-70)+'deg)';

      modals.forEach(function(el){
        var start=parseFloat(el.dataset.start),end=parseFloat(el.dataset.end),side=el.dataset.side;
        var o=fadeWindow(p,start,end);
        var slide=side==='left'?-58*(1-o):side==='right'?58*(1-o):0;
        el.style.opacity=o.toFixed(3);
        el.style.pointerEvents=o>.72?'auto':'none';
        if(mobile){
          el.style.transform='translateY('+(18*(1-o))+'px) scale('+(0.985+.015*o)+')';
        }else if(side==='center'){
          el.style.transform='translate(-50%,-50%) scale('+(0.94+.06*o)+')';
        }else{
          el.style.transform='translateY(-50%) translateX('+slide+'px)';
        }
      });
      var ai=activeIndex(p);
      dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===ai)});
      var cue=root.querySelector('.msx-scroll-cue');
      if(cue)cue.style.opacity=p<.055?'1':'0';
    }

    function tick(){
      current+= (target-current)*.16;
      if(Math.abs(current-target)<.001)current=target;
      render(current);
      if(Math.abs(current-target)>.001){
        rafId=requestAnimationFrame(tick);
      }else{
        ticking=false;rafId=0;
      }
    }

    function updatePageChrome(){
      var y=window.scrollY||document.documentElement.scrollTop||0;
      var max=Math.max(1,document.documentElement.scrollHeight-window.innerHeight);
      if(nav)nav.classList.toggle('is-scrolled',y>40);
      if(progressBar)progressBar.style.width=(clamp(y/max,0,1)*100)+'%';
    }

    function onScroll(){
      target=progress();
      updatePageChrome();
      if(reduced){current=target;render(current);return}
      if(!ticking){ticking=true;rafId=requestAnimationFrame(tick)}
    }

    function hideLoader(){
      if(loaderBar)loaderBar.style.width='100%';
      setTimeout(function(){if(loader)loader.classList.add('is-hidden')},180);
    }
    if(product&&product.complete&&product.naturalWidth){hideLoader()}
    else if(product){
      if(loaderBar)loaderBar.style.width='58%';
      product.addEventListener('load',hideLoader,{once:true});
      product.addEventListener('error',hideLoader,{once:true});
      setTimeout(hideLoader,1800);
    }else hideLoader();

    var fades=[].slice.call(root.querySelectorAll('.msx-fade'));
    var draws=[].slice.call(root.querySelectorAll('[data-draw]'));
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            if(entry.target.hasAttribute('data-draw'))entry.target.classList.add('is-drawn');
            observer.unobserve(entry.target);
          }
        });
      },{threshold:.12,rootMargin:'0px 0px -5% 0px'});
      fades.concat(draws).forEach(function(el){observer.observe(el)});
    }else{
      fades.forEach(function(el){el.classList.add('is-visible')});
      draws.forEach(function(el){el.classList.add('is-drawn')});
    }

    root.querySelectorAll('.msx-nav a[href^="#"],.msx-discover[href^="#"]').forEach(function(link){
      link.addEventListener('click',function(e){
        var targetEl=document.querySelector(link.getAttribute('href'));
        if(targetEl){e.preventDefault();targetEl.scrollIntoView({behavior:'smooth',block:'start'})}
      });
    });

    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',function(){target=progress();current=target;render(current);updatePageChrome()},{passive:true});
    target=progress();current=target;render(current);updatePageChrome();
  }

  function initAll(scope){(scope||document).querySelectorAll('[data-msx]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});
  else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eclat-air-product-backup-scrollfix-20260920"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}
  function lerp(a,b,t){return a+(b-a)*t}
  function pulse(p,c,w){return ease(1-clamp(Math.abs(p-c)/w,0,1))}
  function mix(p,keys){
    if(p<=keys[0][0])return keys[0].slice(1);
    for(var i=0;i<keys.length-1;i++){var a=keys[i],b=keys[i+1];if(p>=a[0]&&p<=b[0]){var t=ease((p-a[0])/(b[0]-a[0])),o=[];for(var j=1;j<a.length;j++)o.push(lerp(a[j],b[j],t));return o}}
    return keys[keys.length-1].slice(1)
  }
  function init(root){
    if(!root||root.dataset.ready)return;root.dataset.ready="1";
    var story=root.querySelector("[data-story]"),product=root.querySelector("[data-product]"),img=root.querySelector("[data-product-img]"),shadow=root.querySelector("[data-shadow]"),halo=root.querySelector("[data-halo]"),o1=root.querySelector("[data-orbit-one]"),o2=root.querySelector("[data-orbit-two]"),d1=root.querySelector("[data-dot-one]"),d2=root.querySelector("[data-dot-two]"),cream=root.querySelector("[data-bg-cream]"),chap=[].slice.call(root.querySelectorAll("[data-chapter]")),steps=[].slice.call(root.querySelectorAll("[data-steps] span")),callouts=root.querySelector("[data-callouts]"),cap=root.querySelector("[data-focus-cap]"),label=root.querySelector("[data-focus-label]"),sig=root.querySelector("[data-signature-art]"),sigPaths=[].slice.call(root.querySelectorAll(".mtx-signature-art path,.mtx-signature-art circle")),spray=root.querySelector("[data-spray]"),breath=root.querySelector("[data-breath]"),rings=[].slice.call(root.querySelectorAll("[data-breath] i")),bar=root.querySelector("[data-progress]"),nav=root.querySelector("[data-nav]"),loader=root.querySelector("[data-loader]"),loaderBar=root.querySelector("[data-loader-bar]"),cue=root.querySelector("[data-scrollcue]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches,current=0,target=0,ticking=false;
    var centers=[.035,.145,.245,.355,.465,.585,.690,.795,.895,.975];
    var keys=[[0,.67,.51,1],[.14,.62,.50,1.07],[.25,.53,.50,1.18],[.36,.70,.50,.82],[.47,.68,.50,.72],[.58,.38,.50,.94],[.69,.39,.50,.94],[.80,.39,.50,.94],[.90,.69,.50,1.02],[1,.69,.50,.88]];
    function prog(){var r=story.getBoundingClientRect(),len=story.offsetHeight-window.innerHeight;return len>0?clamp(-r.top/len,0,1):0}
    function nearest(p){var k=0,z=9;centers.forEach(function(c,i){var n=Math.abs(c-p);if(n<z){z=n;k=i}});return k}
    function show(el,o,s){if(!el)return;el.style.opacity=o.toFixed(3);el.style.transform="translate(-50%,-50%) scale("+(s||1)+")"}
    function render(p){
      var mobile=window.innerWidth<=720,idx=nearest(p),v=mix(p,keys),x=mobile?50:v[0]*100,y=mobile?(idx>=5&&idx<=7?34:37):v[1]*100,s=mobile?Math.min(v[2],1):v[2];
      product.style.left=x+"%";product.style.top=y+"%";product.style.transform="translate(-50%,-50%) scale("+s+")";product.style.opacity=(idx===3||idx===4)?.14:1;
      shadow.style.transform="translateX(-50%) scaleX("+(1+.14*Math.sin(p*15))+")";
      var light=Math.max(pulse(p,.245,.12),pulse(p,.355,.13));cream.style.opacity=(.98*light).toFixed(3);
      var hx=mobile?50:(idx>=5&&idx<=7?39:idx===3||idx===4?68:67),hy=mobile?36:50;[halo,o1,o2,d1,d2].forEach(function(e){e.style.left=hx+"%";e.style.top=hy+"%"});
      var rot=p*420;o1.style.transform="translate(-50%,-50%) rotate("+rot+"deg)";o2.style.transform="translate(-50%,-50%) rotate("+(-rot*.82)+"deg)";d1.style.transform="rotate("+rot+"deg) translateY("+(-Math.min(280,window.innerWidth*.18))+"px)";d2.style.transform="rotate("+(-rot*.82)+"deg) translateY("+(-Math.min(195,window.innerWidth*.13))+"px)";halo.style.transform="translate(-50%,-50%) scale("+(1+.07*Math.sin(p*18))+")";
      chap.forEach(function(el,i){var q=pulse(p,centers[i],i===9?.055:.065);el.style.opacity=q.toFixed(3);el.style.transform=mobile?"translateY("+(18*(1-q))+"px)":"translateY(calc(-50% + "+(28*(1-q))+"px))";el.style.pointerEvents=q>.7?"auto":"none"});
      steps.forEach(function(e,i){e.classList.toggle("is-active",i===idx)});
      var co=pulse(p,.335,.055),lo=pulse(p,.385,.055);show(cap,co,.95+.05*co);show(label,lo,.95+.05*lo);callouts.style.opacity=(pulse(p,.355,.075)*.95).toFixed(3);
      var so=pulse(p,.465,.08);sig.style.opacity=so.toFixed(3);sig.style.transform="translate(-50%,-50%) scale("+(0.95+.05*so)+")";sigPaths.forEach(function(path,i){var draw=clamp((so*1.3)-(i%3)*.08,0,1);path.style.strokeDashoffset=(1000*(1-draw)).toFixed(0)});
      var sp=pulse(p,.690,.065);spray.style.opacity=sp.toFixed(3);[].slice.call(spray.querySelectorAll("i")).forEach(function(e,i){e.style.transform="translate("+(sp*(18+i*4))+"px,"+(-sp*(i%2?10:3))+"px)";e.style.opacity=(sp*(1-i*.05)).toFixed(2)});
      var br=pulse(p,.795,.07);breath.style.opacity=br.toFixed(3);rings.forEach(function(e,i){e.style.transform="translate(-50%,-50%) scale("+(0.80+br*(.18+i*.08))+")";e.style.opacity=(br*(.9-i*.18)).toFixed(2)});
      cue.style.opacity=p<.035?"1":"0";bar.style.width=(p*100)+"%";
      var isLight=light>.52;nav.style.color=isLight?"#2A1D18":"#FAF7F2";nav.style.background=isLight?"rgba(250,247,242,.86)":"rgba(9,5,4,.52)";nav.style.borderBottomColor=isLight?"rgba(42,29,24,.08)":"rgba(255,255,255,.07)";
    }
    function tick(){current+=(target-current)*.16;if(Math.abs(current-target)<.0007)current=target;render(current);if(Math.abs(current-target)>.0007)requestAnimationFrame(tick);else ticking=false}
    function onScroll(){target=prog();if(reduced){current=target;render(current);return}if(!ticking){ticking=true;requestAnimationFrame(tick)}}
    function jump(p){var r=story.getBoundingClientRect(),top=(window.scrollY||document.documentElement.scrollTop)+r.top,len=story.offsetHeight-window.innerHeight;window.scrollTo({top:top+len*clamp(p,0,1),behavior:"smooth"})}
    root.querySelectorAll("[data-jump]").forEach(function(b){b.addEventListener("click",function(){jump(parseFloat(b.dataset.jump)||0)})});
    window.addEventListener("scroll",onScroll,{passive:true});window.addEventListener("resize",function(){target=prog();current=target;render(current)},{passive:true});
    function done(){loaderBar.style.width="100%";setTimeout(function(){loader.classList.add("is-hidden")},140)}
    if(img&&img.complete&&img.naturalWidth)done();else{loaderBar.style.width="55%";img.addEventListener("load",done,{once:true});img.addEventListener("error",done,{once:true});setTimeout(done,1800)}
    target=prog();current=target;render(current)
  }
  function start(scope){(scope||document).querySelectorAll("[data-mtx]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){start(document)});else start(document);
  document.addEventListener("shopify:section:load",function(e){start(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtx-backup-before-inversion-20260920-2041"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}

  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var cream=root.querySelector("[data-bg-cream]");
    var shadow=root.querySelector("[data-shadow]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var active=-1;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var desktopFrames=[
      {x:68,y:51,s:1.00,light:0,halo:.92,orbit:.58},
      {x:67,y:50,s:1.07,light:1,halo:.72,orbit:.18},
      {x:35,y:50,s:1.14,light:1,halo:.64,orbit:.10},
      {x:69,y:66,s:1.50,light:1,halo:.48,orbit:.00},
      {x:31,y:36,s:1.48,light:1,halo:.46,orbit:.00},
      {x:69,y:50,s:.86,light:0,halo:.72,orbit:.26},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:.92,light:0,halo:.80,orbit:.00},
      {x:69,y:50,s:1.08,light:0,halo:.82,orbit:.24},
      {x:78,y:49,s:.68,light:1,halo:.50,orbit:.12}
    ];

    var tabletFrames=[
      {x:67,y:51,s:.96,light:0,halo:.90,orbit:.50},
      {x:66,y:50,s:1.00,light:1,halo:.70,orbit:.16},
      {x:34,y:50,s:1.04,light:1,halo:.62,orbit:.10},
      {x:67,y:62,s:1.24,light:1,halo:.48,orbit:.00},
      {x:33,y:38,s:1.22,light:1,halo:.46,orbit:.00},
      {x:67,y:50,s:.84,light:0,halo:.70,orbit:.22},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.89,light:0,halo:.78,orbit:.00},
      {x:67,y:50,s:1.00,light:0,halo:.80,orbit:.20},
      {x:76,y:49,s:.66,light:1,halo:.48,orbit:.10}
    ];

    var mobileFrames=[
      {x:50,y:31,s:.90,light:0,halo:.86,orbit:.44},
      {x:50,y:30,s:.95,light:1,halo:.64,orbit:.12},
      {x:50,y:31,s:.99,light:1,halo:.58,orbit:.08},
      {x:50,y:37,s:1.08,light:1,halo:.42,orbit:.00},
      {x:50,y:24,s:1.06,light:1,halo:.42,orbit:.00},
      {x:50,y:31,s:.84,light:0,halo:.66,orbit:.18},
      {x:50,y:31,s:.91,light:0,halo:.70,orbit:.00},
      {x:50,y:31,s:.91,light:0,halo:.70,orbit:.00},
      {x:50,y:31,s:.86,light:0,halo:.74,orbit:.00},
      {x:50,y:31,s:.95,light:0,halo:.76,orbit:.16},
      {x:50,y:29,s:.73,light:1,halo:.44,orbit:.08}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop;
    }
    function viewportH(){
      return scroller===window?(window.innerHeight||document.documentElement.clientHeight):scroller.clientHeight;
    }
    function storyTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top);
    }
    function timelineProgress(){
      if(!steps.length)return 0;
      var base=scroller===window?0:scroller.getBoundingClientRect().top;
      var marker=viewportH()*.52;
      var centers=steps.map(function(step){
        var r=step.getBoundingClientRect();
        return (r.top-base)+r.height*.5;
      });
      if(marker<=centers[0])return 0;
      var last=centers.length-1;
      if(marker>=centers[last])return 1;
      for(var i=0;i<last;i++){
        if(marker>=centers[i]&&marker<=centers[i+1]){
          var span=Math.max(1,centers[i+1]-centers[i]);
          var local=(marker-centers[i])/span;
          return (i+clamp(local,0,1))/last;
        }
      }
      return 0;
    }
    function activeFromViewport(){
      return Math.round(timelineProgress()*(steps.length-1));
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i)return;
      active=i;
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var frames=window.innerWidth<=720?mobileFrames:(window.innerWidth<=1100?tabletFrames:desktopFrames);
      var n=frames.length-1;
      var exact=clamp(p,0,1)*n;
      var a=Math.floor(exact);
      var b=Math.min(n,a+1);
      var t=ease(exact-a);
      var fa=frames[a],fb=frames[b];

      var x=lerp(fa.x,fb.x,t);
      var y=lerp(fa.y,fb.y,t);
      var s=lerp(fa.s,fb.s,t);
      var light=lerp(fa.light,fb.light,t);
      var haloOpacity=lerp(fa.halo,fb.halo,t);
      var orbitOpacity=lerp(fa.orbit,fb.orbit,t);

      product.style.left=x+"%";
      product.style.top=y+"%";
      product.style.transform="translate3d(-50%,-50%,0) scale("+s+")";
      halo.style.left=x+"%";
      halo.style.top=y+"%";
      orbitOne.style.left=x+"%";
      orbitOne.style.top=y+"%";
      orbitTwo.style.left=x+"%";
      orbitTwo.style.top=y+"%";
      dotOne.style.left=x+"%";
      dotOne.style.top=y+"%";
      dotTwo.style.left=x+"%";
      dotTwo.style.top=y+"%";

      cream.style.opacity=light.toFixed(3);
      halo.style.opacity=haloOpacity.toFixed(3);
      orbitOne.style.opacity=orbitOpacity.toFixed(3);
      orbitTwo.style.opacity=(orbitOpacity*.62).toFixed(3);
      dotOne.style.opacity=(orbitOpacity*.92).toFixed(3);
      dotTwo.style.opacity=(orbitOpacity*.72).toFixed(3);
      shadow.style.opacity=clamp(.82-(s-1)*.18,.48,.88).toFixed(3);

      var rot=p*360;
      orbitOne.style.transform="translate3d(-50%,-50%,0) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate3d(-50%,-50%,0) rotate("+(-rot*.78)+"deg)";

      var mobile=window.innerWidth<=720;
      var r1=Math.min(282,window.innerWidth*(mobile?.34:.18));
      var r2=Math.min(198,window.innerWidth*(mobile?.23:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.78)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100).toFixed(2)+"%";
    }
    function tick(){
      currentP+=(targetP-currentP)*.16;
      if(Math.abs(targetP-currentP)<.0005)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0005){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=timelineProgress();
      setActive(activeFromViewport());
      if(reduced){
        currentP=targetP;
        stageRender(currentP);
        return;
      }
      if(!raf)raf=requestAnimationFrame(tick);
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }
    }

    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)});
    });

    if(stage&&!reduced&&window.matchMedia("(pointer:fine)").matches){
      stage.addEventListener("pointermove",function(e){
        var r=stage.getBoundingClientRect();
        var px=clamp((e.clientX-r.left)/r.width,0,1)-.5;
        var py=clamp((e.clientY-r.top)/r.height,0,1)-.5;
        productImg.style.setProperty("--tilt-x",(px*2.4).toFixed(2)+"deg");
        productImg.style.setProperty("--tilt-y",(-py*1.8).toFixed(2)+"deg");
      });
      stage.addEventListener("pointerleave",function(){
        productImg.style.setProperty("--tilt-x","0deg");
        productImg.style.setProperty("--tilt-y","0deg");
      });
    }

    scroller.addEventListener("scroll",onScroll,{passive:true});
    var resizeRaf=0;
    window.addEventListener("resize",function(){
      if(resizeRaf)return;
      resizeRaf=requestAnimationFrame(function(){
        resizeRaf=0;
        var nextScroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
        if(nextScroller!==scroller){
          scroller.removeEventListener("scroll",onScroll);
          scroller=nextScroller;
          scroller.addEventListener("scroll",onScroll,{passive:true});
        }
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      });
    },{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120);
    }
    loaderBar.style.width="62%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700);
    }else done();

    setActive(activeFromViewport());
    targetP=timelineProgress();
    currentP=targetP;
    stageRender(currentP);
  }

  function start(scope){
    (scope||document).querySelectorAll("[data-mtx]").forEach(init);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){start(document)});
  }else{
    start(document);
  }

  document.addEventListener("shopify:section:load",function(e){start(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtx-backup-before-mobile-parity-20260920-2050"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}

  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var cream=root.querySelector("[data-bg-cream]");
    var shadow=root.querySelector("[data-shadow]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var active=-1;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var desktopFrames=[
      {x:68,y:51,s:1.00,light:0,halo:.92,orbit:.58},
      {x:67,y:50,s:1.07,light:1,halo:.72,orbit:.18},
      {x:35,y:50,s:1.14,light:1,halo:.64,orbit:.10},
      {x:69,y:66,s:1.50,light:1,halo:.48,orbit:.00},
      {x:31,y:36,s:1.48,light:1,halo:.46,orbit:.00},
      {x:69,y:50,s:.86,light:0,halo:.72,orbit:.26},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:.92,light:0,halo:.80,orbit:.00},
      {x:69,y:50,s:1.08,light:0,halo:.82,orbit:.24},
      {x:78,y:49,s:.68,light:1,halo:.50,orbit:.12}
    ];

    var tabletFrames=[
      {x:67,y:51,s:.96,light:0,halo:.90,orbit:.50},
      {x:66,y:50,s:1.00,light:1,halo:.70,orbit:.16},
      {x:34,y:50,s:1.04,light:1,halo:.62,orbit:.10},
      {x:67,y:62,s:1.24,light:1,halo:.48,orbit:.00},
      {x:33,y:38,s:1.22,light:1,halo:.46,orbit:.00},
      {x:67,y:50,s:.84,light:0,halo:.70,orbit:.22},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.89,light:0,halo:.78,orbit:.00},
      {x:67,y:50,s:1.00,light:0,halo:.80,orbit:.20},
      {x:76,y:49,s:.66,light:1,halo:.48,orbit:.10}
    ];

    var mobileFrames=[
      {x:50,y:31,s:.90,light:0,halo:.86,orbit:.44},
      {x:50,y:30,s:.95,light:1,halo:.64,orbit:.12},
      {x:50,y:31,s:.99,light:1,halo:.58,orbit:.08},
      {x:50,y:37,s:1.08,light:1,halo:.42,orbit:.00},
      {x:50,y:24,s:1.06,light:1,halo:.42,orbit:.00},
      {x:50,y:31,s:.84,light:0,halo:.66,orbit:.18},
      {x:50,y:31,s:.91,light:0,halo:.70,orbit:.00},
      {x:50,y:31,s:.91,light:0,halo:.70,orbit:.00},
      {x:50,y:31,s:.86,light:0,halo:.74,orbit:.00},
      {x:50,y:31,s:.95,light:0,halo:.76,orbit:.16},
      {x:50,y:29,s:.73,light:1,halo:.44,orbit:.08}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop;
    }
    function viewportH(){
      return scroller===window?(window.innerHeight||document.documentElement.clientHeight):scroller.clientHeight;
    }
    function storyTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top);
    }
    function timelineProgress(){
      if(!steps.length)return 0;
      var base=scroller===window?0:scroller.getBoundingClientRect().top;
      var marker=viewportH()*.52;
      var centers=steps.map(function(step){
        var r=step.getBoundingClientRect();
        return (r.top-base)+r.height*.5;
      });
      if(marker<=centers[0])return 0;
      var last=centers.length-1;
      if(marker>=centers[last])return 1;
      for(var i=0;i<last;i++){
        if(marker>=centers[i]&&marker<=centers[i+1]){
          var span=Math.max(1,centers[i+1]-centers[i]);
          var local=(marker-centers[i])/span;
          return (i+clamp(local,0,1))/last;
        }
      }
      return 0;
    }
    function activeFromViewport(){
      return Math.round(timelineProgress()*(steps.length-1));
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i)return;
      active=i;
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var frames=window.innerWidth<=720?mobileFrames:(window.innerWidth<=1100?tabletFrames:desktopFrames);
      var n=frames.length-1;
      var exact=clamp(p,0,1)*n;
      var a=Math.floor(exact);
      var b=Math.min(n,a+1);
      var t=ease(exact-a);
      var fa=frames[a],fb=frames[b];

      var x=lerp(fa.x,fb.x,t);
      var y=lerp(fa.y,fb.y,t);
      var s=lerp(fa.s,fb.s,t);
      var light=lerp(fa.light,fb.light,t);
      var haloOpacity=lerp(fa.halo,fb.halo,t);
      var orbitOpacity=lerp(fa.orbit,fb.orbit,t);

      product.style.left=x+"%";
      product.style.top=y+"%";
      product.style.transform="translate3d(-50%,-50%,0) scale("+s+")";
      halo.style.left=x+"%";
      halo.style.top=y+"%";
      orbitOne.style.left=x+"%";
      orbitOne.style.top=y+"%";
      orbitTwo.style.left=x+"%";
      orbitTwo.style.top=y+"%";
      dotOne.style.left=x+"%";
      dotOne.style.top=y+"%";
      dotTwo.style.left=x+"%";
      dotTwo.style.top=y+"%";

      cream.style.opacity=light.toFixed(3);
      halo.style.opacity=haloOpacity.toFixed(3);
      orbitOne.style.opacity=orbitOpacity.toFixed(3);
      orbitTwo.style.opacity=(orbitOpacity*.62).toFixed(3);
      dotOne.style.opacity=(orbitOpacity*.92).toFixed(3);
      dotTwo.style.opacity=(orbitOpacity*.72).toFixed(3);
      shadow.style.opacity=clamp(.82-(s-1)*.18,.48,.88).toFixed(3);

      var rot=p*360;
      orbitOne.style.transform="translate3d(-50%,-50%,0) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate3d(-50%,-50%,0) rotate("+(-rot*.78)+"deg)";

      var mobile=window.innerWidth<=720;
      var r1=Math.min(282,window.innerWidth*(mobile?.34:.18));
      var r2=Math.min(198,window.innerWidth*(mobile?.23:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.78)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100).toFixed(2)+"%";
    }
    function tick(){
      currentP+=(targetP-currentP)*.16;
      if(Math.abs(targetP-currentP)<.0005)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0005){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=timelineProgress();
      setActive(activeFromViewport());
      if(reduced){
        currentP=targetP;
        stageRender(currentP);
        return;
      }
      if(!raf)raf=requestAnimationFrame(tick);
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }
    }

    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)});
    });

    if(stage&&!reduced&&window.matchMedia("(pointer:fine)").matches){
      stage.addEventListener("pointermove",function(e){
        var r=stage.getBoundingClientRect();
        var px=clamp((e.clientX-r.left)/r.width,0,1)-.5;
        var py=clamp((e.clientY-r.top)/r.height,0,1)-.5;
        productImg.style.setProperty("--tilt-x",(px*2.4).toFixed(2)+"deg");
        productImg.style.setProperty("--tilt-y",(-py*1.8).toFixed(2)+"deg");
      });
      stage.addEventListener("pointerleave",function(){
        productImg.style.setProperty("--tilt-x","0deg");
        productImg.style.setProperty("--tilt-y","0deg");
      });
    }

    scroller.addEventListener("scroll",onScroll,{passive:true});
    var resizeRaf=0;
    window.addEventListener("resize",function(){
      if(resizeRaf)return;
      resizeRaf=requestAnimationFrame(function(){
        resizeRaf=0;
        var nextScroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
        if(nextScroller!==scroller){
          scroller.removeEventListener("scroll",onScroll);
          scroller=nextScroller;
          scroller.addEventListener("scroll",onScroll,{passive:true});
        }
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      });
    },{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120);
    }
    loaderBar.style.width="62%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700);
    }else done();

    setActive(activeFromViewport());
    targetP=timelineProgress();
    currentP=targetP;
    stageRender(currentP);
  }

  function start(scope){
    (scope||document).querySelectorAll("[data-mtx]").forEach(init);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){start(document)});
  }else{
    start(document);
  }

  document.addEventListener("shopify:section:load",function(e){start(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtx-bak-1657"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}

  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var cream=root.querySelector("[data-bg-cream]");
    var shadow=root.querySelector("[data-shadow]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var active=-1;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var desktopFrames=[
      {x:68,y:51,s:1.00,light:0,halo:.92,orbit:.58},
      {x:67,y:50,s:1.07,light:1,halo:.72,orbit:.18},
      {x:35,y:50,s:1.14,light:1,halo:.64,orbit:.10},
      {x:69,y:66,s:1.50,light:1,halo:.48,orbit:.00},
      {x:31,y:36,s:1.48,light:1,halo:.46,orbit:.00},
      {x:69,y:50,s:.86,light:0,halo:.72,orbit:.26},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:.92,light:0,halo:.80,orbit:.00},
      {x:69,y:50,s:1.08,light:0,halo:.82,orbit:.24},
      {x:78,y:49,s:.68,light:1,halo:.50,orbit:.12}
    ];

    var mobileFrames=[
      {x:50,y:31,s:.92,light:0,halo:.88,orbit:.50},
      {x:50,y:30,s:.98,light:1,halo:.66,orbit:.12},
      {x:50,y:31,s:1.02,light:1,halo:.60,orbit:.08},
      {x:50,y:39,s:1.15,light:1,halo:.44,orbit:.00},
      {x:50,y:22,s:1.12,light:1,halo:.44,orbit:.00},
      {x:50,y:31,s:.86,light:0,halo:.68,orbit:.20},
      {x:50,y:31,s:.94,light:0,halo:.72,orbit:.00},
      {x:50,y:31,s:.94,light:0,halo:.72,orbit:.00},
      {x:50,y:31,s:.88,light:0,halo:.76,orbit:.00},
      {x:50,y:31,s:.98,light:0,halo:.78,orbit:.18},
      {x:50,y:28,s:.76,light:1,halo:.46,orbit:.08}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop;
    }
    function viewportH(){
      return scroller===window?(window.innerHeight||document.documentElement.clientHeight):scroller.clientHeight;
    }
    function storyTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top);
    }
    function storyProgress(){
      var top=storyTop();
      var len=Math.max(1,story.offsetHeight-viewportH());
      return clamp((scrollTop()-top)/len,0,1);
    }
    function activeFromViewport(){
      var vh=viewportH();
      var base=scroller===window?0:scroller.getBoundingClientRect().top;
      var best=0;
      var bestDist=Infinity;
      steps.forEach(function(step,i){
        var r=step.getBoundingClientRect();
        var center=(r.top-base)+r.height*.5;
        var d=Math.abs(center-vh*.52);
        if(d<bestDist){bestDist=d;best=i}
      });
      return best;
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i)return;
      active=i;
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var frames=window.innerWidth<=720?mobileFrames:desktopFrames;
      var n=frames.length-1;
      var exact=clamp(p,0,1)*n;
      var a=Math.floor(exact);
      var b=Math.min(n,a+1);
      var t=ease(exact-a);
      var fa=frames[a],fb=frames[b];

      var x=lerp(fa.x,fb.x,t);
      var y=lerp(fa.y,fb.y,t);
      var s=lerp(fa.s,fb.s,t);
      var light=lerp(fa.light,fb.light,t);
      var haloOpacity=lerp(fa.halo,fb.halo,t);
      var orbitOpacity=lerp(fa.orbit,fb.orbit,t);

      product.style.left=x+"%";
      product.style.top=y+"%";
      product.style.transform="translate3d(-50%,-50%,0) scale("+s+")";
      halo.style.left=x+"%";
      halo.style.top=y+"%";
      orbitOne.style.left=x+"%";
      orbitOne.style.top=y+"%";
      orbitTwo.style.left=x+"%";
      orbitTwo.style.top=y+"%";
      dotOne.style.left=x+"%";
      dotOne.style.top=y+"%";
      dotTwo.style.left=x+"%";
      dotTwo.style.top=y+"%";

      cream.style.opacity=light.toFixed(3);
      halo.style.opacity=haloOpacity.toFixed(3);
      orbitOne.style.opacity=orbitOpacity.toFixed(3);
      orbitTwo.style.opacity=(orbitOpacity*.62).toFixed(3);
      dotOne.style.opacity=(orbitOpacity*.92).toFixed(3);
      dotTwo.style.opacity=(orbitOpacity*.72).toFixed(3);
      shadow.style.opacity=clamp(.82-(s-1)*.18,.48,.88).toFixed(3);

      var rot=p*360;
      orbitOne.style.transform="translate3d(-50%,-50%,0) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate3d(-50%,-50%,0) rotate("+(-rot*.78)+"deg)";

      var mobile=window.innerWidth<=720;
      var r1=Math.min(282,window.innerWidth*(mobile?.34:.18));
      var r2=Math.min(198,window.innerWidth*(mobile?.23:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.78)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100).toFixed(2)+"%";
    }
    function tick(){
      currentP+=(targetP-currentP)*.16;
      if(Math.abs(targetP-currentP)<.0005)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0005){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=storyProgress();
      setActive(activeFromViewport());
      if(reduced){
        currentP=targetP;
        stageRender(currentP);
        return;
      }
      if(!raf)raf=requestAnimationFrame(tick);
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }
    }

    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)});
    });

    if(stage&&!reduced&&window.matchMedia("(pointer:fine)").matches){
      stage.addEventListener("pointermove",function(e){
        var r=stage.getBoundingClientRect();
        var px=clamp((e.clientX-r.left)/r.width,0,1)-.5;
        var py=clamp((e.clientY-r.top)/r.height,0,1)-.5;
        productImg.style.setProperty("--tilt-x",(px*2.4).toFixed(2)+"deg");
        productImg.style.setProperty("--tilt-y",(-py*1.8).toFixed(2)+"deg");
      });
      stage.addEventListener("pointerleave",function(){
        productImg.style.setProperty("--tilt-x","0deg");
        productImg.style.setProperty("--tilt-y","0deg");
      });
    }

    scroller.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){
      var nextScroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
      if(nextScroller!==scroller){
        scroller.removeEventListener("scroll",onScroll);
        scroller=nextScroller;
        scroller.addEventListener("scroll",onScroll,{passive:true});
      }
      targetP=storyProgress();
      currentP=targetP;
      setActive(activeFromViewport());
      stageRender(currentP);
    },{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120);
    }
    loaderBar.style.width="62%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700);
    }else done();

    setActive(activeFromViewport());
    targetP=storyProgress();
    currentP=targetP;
    stageRender(currentP);
  }

  function start(scope){
    (scope||document).querySelectorAll("[data-mtx]").forEach(init);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){start(document)});
  }else{
    start(document);
  }

  document.addEventListener("shopify:section:load",function(e){start(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtx-bak-1701"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}

  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=pageWrapper||window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var cream=root.querySelector("[data-bg-cream]");
    var shadow=root.querySelector("[data-shadow]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var active=-1;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var desktopFrames=[
      {x:68,y:51,s:1.00,light:0,halo:.92,orbit:.58},
      {x:67,y:50,s:1.07,light:1,halo:.72,orbit:.18},
      {x:35,y:50,s:1.14,light:1,halo:.64,orbit:.10},
      {x:69,y:66,s:1.50,light:1,halo:.48,orbit:.00},
      {x:31,y:36,s:1.48,light:1,halo:.46,orbit:.00},
      {x:69,y:50,s:.86,light:0,halo:.72,orbit:.26},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:.92,light:0,halo:.80,orbit:.00},
      {x:69,y:50,s:1.08,light:0,halo:.82,orbit:.24},
      {x:78,y:49,s:.68,light:1,halo:.50,orbit:.12}
    ];

    var tabletFrames=[
      {x:67,y:51,s:.96,light:0,halo:.90,orbit:.50},
      {x:66,y:50,s:1.00,light:1,halo:.70,orbit:.16},
      {x:34,y:50,s:1.04,light:1,halo:.62,orbit:.10},
      {x:67,y:62,s:1.24,light:1,halo:.48,orbit:.00},
      {x:33,y:38,s:1.22,light:1,halo:.46,orbit:.00},
      {x:67,y:50,s:.84,light:0,halo:.70,orbit:.22},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.89,light:0,halo:.78,orbit:.00},
      {x:67,y:50,s:1.00,light:0,halo:.80,orbit:.20},
      {x:76,y:49,s:.66,light:1,halo:.48,orbit:.10}
    ];

    var mobileFrames=[
      {x:50,y:31,s:.90,light:0,halo:.86,orbit:.44},
      {x:50,y:30,s:.95,light:1,halo:.64,orbit:.12},
      {x:50,y:31,s:.99,light:1,halo:.58,orbit:.08},
      {x:50,y:37,s:1.08,light:1,halo:.42,orbit:.00},
      {x:50,y:24,s:1.06,light:1,halo:.42,orbit:.00},
      {x:50,y:31,s:.84,light:0,halo:.66,orbit:.18},
      {x:50,y:31,s:.91,light:0,halo:.70,orbit:.00},
      {x:50,y:31,s:.91,light:0,halo:.70,orbit:.00},
      {x:50,y:31,s:.86,light:0,halo:.74,orbit:.00},
      {x:50,y:31,s:.95,light:0,halo:.76,orbit:.16},
      {x:50,y:29,s:.73,light:1,halo:.44,orbit:.08}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop;
    }
    function viewportH(){
      return scroller===window?(window.innerHeight||document.documentElement.clientHeight):scroller.clientHeight;
    }
    function storyTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top);
    }
    function timelineProgress(){
      if(!steps.length)return 0;
      var base=scroller===window?0:scroller.getBoundingClientRect().top;
      var marker=viewportH()*.52;
      var centers=steps.map(function(step){
        var r=step.getBoundingClientRect();
        return (r.top-base)+r.height*.5;
      });
      if(marker<=centers[0])return 0;
      var last=centers.length-1;
      if(marker>=centers[last])return 1;
      for(var i=0;i<last;i++){
        if(marker>=centers[i]&&marker<=centers[i+1]){
          var span=Math.max(1,centers[i+1]-centers[i]);
          var local=(marker-centers[i])/span;
          return (i+clamp(local,0,1))/last;
        }
      }
      return 0;
    }
    function activeFromViewport(){
      return Math.round(timelineProgress()*(steps.length-1));
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i)return;
      active=i;
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var frames=window.innerWidth<=720?mobileFrames:(window.innerWidth<=1100?tabletFrames:desktopFrames);
      var n=frames.length-1;
      var exact=clamp(p,0,1)*n;
      var a=Math.floor(exact);
      var b=Math.min(n,a+1);
      var t=ease(exact-a);
      var fa=frames[a],fb=frames[b];

      var x=lerp(fa.x,fb.x,t);
      var y=lerp(fa.y,fb.y,t);
      var s=lerp(fa.s,fb.s,t);
      var light=lerp(fa.light,fb.light,t);
      var haloOpacity=lerp(fa.halo,fb.halo,t);
      var orbitOpacity=lerp(fa.orbit,fb.orbit,t);

      product.style.left=x+"%";
      product.style.top=y+"%";
      product.style.transform="translate3d(-50%,-50%,0) scale("+s+")";
      halo.style.left=x+"%";
      halo.style.top=y+"%";
      orbitOne.style.left=x+"%";
      orbitOne.style.top=y+"%";
      orbitTwo.style.left=x+"%";
      orbitTwo.style.top=y+"%";
      dotOne.style.left=x+"%";
      dotOne.style.top=y+"%";
      dotTwo.style.left=x+"%";
      dotTwo.style.top=y+"%";

      cream.style.opacity=light.toFixed(3);
      halo.style.opacity=haloOpacity.toFixed(3);
      orbitOne.style.opacity=orbitOpacity.toFixed(3);
      orbitTwo.style.opacity=(orbitOpacity*.62).toFixed(3);
      dotOne.style.opacity=(orbitOpacity*.92).toFixed(3);
      dotTwo.style.opacity=(orbitOpacity*.72).toFixed(3);
      shadow.style.opacity=clamp(.82-(s-1)*.18,.48,.88).toFixed(3);

      var rot=p*360;
      orbitOne.style.transform="translate3d(-50%,-50%,0) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate3d(-50%,-50%,0) rotate("+(-rot*.78)+"deg)";

      var mobile=window.innerWidth<=720;
      var r1=Math.min(282,window.innerWidth*(mobile?.34:.18));
      var r2=Math.min(198,window.innerWidth*(mobile?.23:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.78)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100).toFixed(2)+"%";
    }
    function tick(){
      currentP+=(targetP-currentP)*.16;
      if(Math.abs(targetP-currentP)<.0005)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0005){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=timelineProgress();
      setActive(activeFromViewport());
      if(reduced){
        currentP=targetP;
        stageRender(currentP);
        return;
      }
      if(!raf)raf=requestAnimationFrame(tick);
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }
    }

    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)});
    });

    if(stage&&!reduced&&window.matchMedia("(pointer:fine)").matches){
      stage.addEventListener("pointermove",function(e){
        var r=stage.getBoundingClientRect();
        var px=clamp((e.clientX-r.left)/r.width,0,1)-.5;
        var py=clamp((e.clientY-r.top)/r.height,0,1)-.5;
        productImg.style.setProperty("--tilt-x",(px*2.4).toFixed(2)+"deg");
        productImg.style.setProperty("--tilt-y",(-py*1.8).toFixed(2)+"deg");
      });
      stage.addEventListener("pointerleave",function(){
        productImg.style.setProperty("--tilt-x","0deg");
        productImg.style.setProperty("--tilt-y","0deg");
      });
    }

    scroller.addEventListener("scroll",onScroll,{passive:true});
    var resizeRaf=0;
    window.addEventListener("resize",function(){
      if(resizeRaf)return;
      resizeRaf=requestAnimationFrame(function(){
        resizeRaf=0;
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      });
    },{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120);
    }
    loaderBar.style.width="62%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700);
    }else done();

    setActive(activeFromViewport());
    targetP=timelineProgress();
    currentP=targetP;
    stageRender(currentP);
  }

  function start(scope){
    (scope||document).querySelectorAll("[data-mtx]").forEach(init);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){start(document)});
  }else{
    start(document);
  }

  document.addEventListener("shopify:section:load",function(e){start(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtx-bak-mobfx-1903"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}

  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var cream=root.querySelector("[data-bg-cream]");
    var shadow=root.querySelector("[data-shadow]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function syncViewportHeight(){
      if(window.innerWidth>720){
        root.style.removeProperty("--mtx-vh");
        return;
      }
      var h=(window.visualViewport&&window.visualViewport.height)||window.innerHeight||document.documentElement.clientHeight;
      if(h>0)root.style.setProperty("--mtx-vh",Math.round(h)+"px");
    }
    syncViewportHeight();

    var active=-1;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var desktopFrames=[
      {x:68,y:51,s:1.00,light:0,halo:.92,orbit:.58},
      {x:67,y:50,s:1.07,light:1,halo:.72,orbit:.18},
      {x:35,y:50,s:1.14,light:1,halo:.64,orbit:.10},
      {x:69,y:66,s:1.50,light:1,halo:.48,orbit:.00},
      {x:31,y:36,s:1.48,light:1,halo:.46,orbit:.00},
      {x:69,y:50,s:.86,light:0,halo:.72,orbit:.26},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:.92,light:0,halo:.80,orbit:.00},
      {x:69,y:50,s:1.08,light:0,halo:.82,orbit:.24},
      {x:78,y:49,s:.68,light:1,halo:.50,orbit:.12}
    ];

    var tabletFrames=[
      {x:67,y:51,s:.96,light:0,halo:.90,orbit:.50},
      {x:66,y:50,s:1.00,light:1,halo:.70,orbit:.16},
      {x:34,y:50,s:1.04,light:1,halo:.62,orbit:.10},
      {x:67,y:62,s:1.24,light:1,halo:.48,orbit:.00},
      {x:33,y:38,s:1.22,light:1,halo:.46,orbit:.00},
      {x:67,y:50,s:.84,light:0,halo:.70,orbit:.22},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.89,light:0,halo:.78,orbit:.00},
      {x:67,y:50,s:1.00,light:0,halo:.80,orbit:.20},
      {x:76,y:49,s:.66,light:1,halo:.48,orbit:.10}
    ];

    var mobileFrames=[
      {x:62,y:28,s:.92,light:0,halo:.86,orbit:.44},
      {x:62,y:27.5,s:.98,light:.18,halo:.70,orbit:.22},
      {x:38,y:27.5,s:1.02,light:.24,halo:.66,orbit:.16},
      {x:62,y:26.5,s:1.10,light:.30,halo:.58,orbit:.10},
      {x:38,y:26.5,s:1.10,light:.34,halo:.56,orbit:.08},
      {x:62,y:28,s:.90,light:.18,halo:.70,orbit:.18},
      {x:50,y:28,s:.96,light:.12,halo:.72,orbit:.10},
      {x:50,y:28,s:.96,light:.12,halo:.72,orbit:.08},
      {x:50,y:28,s:.92,light:.10,halo:.76,orbit:.08},
      {x:62,y:28,s:1.00,light:.16,halo:.78,orbit:.16},
      {x:50,y:27,s:.78,light:.28,halo:.62,orbit:.10}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop;
    }
    function viewportH(){
      return scroller===window?(window.innerHeight||document.documentElement.clientHeight):scroller.clientHeight;
    }
    function storyTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top);
    }
    function timelineProgress(){
      if(!steps.length)return 0;
      var base=scroller===window?0:scroller.getBoundingClientRect().top;
      var marker=viewportH()*.52;
      var centers=steps.map(function(step){
        var r=step.getBoundingClientRect();
        return (r.top-base)+r.height*.5;
      });
      if(marker<=centers[0])return 0;
      var last=centers.length-1;
      if(marker>=centers[last])return 1;
      for(var i=0;i<last;i++){
        if(marker>=centers[i]&&marker<=centers[i+1]){
          var span=Math.max(1,centers[i+1]-centers[i]);
          var local=(marker-centers[i])/span;
          return (i+clamp(local,0,1))/last;
        }
      }
      return 0;
    }
    function activeFromViewport(){
      if(window.innerWidth<=720){
        var base=scroller===window?0:scroller.getBoundingClientRect().top;
        var vh=viewportH();
        var best=0;
        var bestVisible=-1;
        steps.forEach(function(step,i){
          var r=step.getBoundingClientRect();
          var top=r.top-base;
          var bottom=r.bottom-base;
          var visible=Math.max(0,Math.min(bottom,vh)-Math.max(top,0));
          if(visible>bestVisible){
            bestVisible=visible;
            best=i;
          }
        });
        return best;
      }
      return Math.round(timelineProgress()*(steps.length-1));
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i)return;
      active=i;
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",false);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var frames=window.innerWidth<=720?mobileFrames:(window.innerWidth<=1100?tabletFrames:desktopFrames);
      var n=frames.length-1;
      var exact=clamp(p,0,1)*n;
      var a=Math.floor(exact);
      var b=Math.min(n,a+1);
      var t=ease(exact-a);
      var fa=frames[a],fb=frames[b];

      var x=lerp(fa.x,fb.x,t);
      var y=lerp(fa.y,fb.y,t);
      var s=lerp(fa.s,fb.s,t);
      var light=lerp(fa.light,fb.light,t);
      var haloOpacity=lerp(fa.halo,fb.halo,t);
      var orbitOpacity=lerp(fa.orbit,fb.orbit,t);

      product.style.left=x+"%";
      product.style.top=y+"%";
      product.style.transform="translate3d(-50%,-50%,0) scale("+s+")";
      halo.style.left=x+"%";
      halo.style.top=y+"%";
      orbitOne.style.left=x+"%";
      orbitOne.style.top=y+"%";
      orbitTwo.style.left=x+"%";
      orbitTwo.style.top=y+"%";
      dotOne.style.left=x+"%";
      dotOne.style.top=y+"%";
      dotTwo.style.left=x+"%";
      dotTwo.style.top=y+"%";

      cream.style.opacity=light.toFixed(3);
      halo.style.opacity=haloOpacity.toFixed(3);
      orbitOne.style.opacity=orbitOpacity.toFixed(3);
      orbitTwo.style.opacity=(orbitOpacity*.62).toFixed(3);
      dotOne.style.opacity=(orbitOpacity*.92).toFixed(3);
      dotTwo.style.opacity=(orbitOpacity*.72).toFixed(3);
      shadow.style.opacity=clamp(.82-(s-1)*.18,.48,.88).toFixed(3);

      var rot=p*360;
      orbitOne.style.transform="translate3d(-50%,-50%,0) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate3d(-50%,-50%,0) rotate("+(-rot*.78)+"deg)";

      var mobile=window.innerWidth<=720;
      var r1=Math.min(282,window.innerWidth*(mobile?.34:.18));
      var r2=Math.min(198,window.innerWidth*(mobile?.23:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.78)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100).toFixed(2)+"%";
    }
    function tick(){
      currentP+=(targetP-currentP)*.16;
      if(Math.abs(targetP-currentP)<.0005)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0005){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=timelineProgress();
      setActive(activeFromViewport());
      if(reduced){
        currentP=targetP;
        stageRender(currentP);
        return;
      }
      if(!raf)raf=requestAnimationFrame(tick);
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }
    }

    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)});
    });

    if(stage&&!reduced&&window.matchMedia("(pointer:fine)").matches){
      stage.addEventListener("pointermove",function(e){
        var r=stage.getBoundingClientRect();
        var px=clamp((e.clientX-r.left)/r.width,0,1)-.5;
        var py=clamp((e.clientY-r.top)/r.height,0,1)-.5;
        productImg.style.setProperty("--tilt-x",(px*2.4).toFixed(2)+"deg");
        productImg.style.setProperty("--tilt-y",(-py*1.8).toFixed(2)+"deg");
      });
      stage.addEventListener("pointerleave",function(){
        productImg.style.setProperty("--tilt-x","0deg");
        productImg.style.setProperty("--tilt-y","0deg");
      });
    }

    scroller.addEventListener("scroll",onScroll,{passive:true});
    var resizeRaf=0;
    window.addEventListener("resize",function(){
      syncViewportHeight();
      if(resizeRaf)return;
      resizeRaf=requestAnimationFrame(function(){
        resizeRaf=0;
        var nextScroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
        if(nextScroller!==scroller){
          scroller.removeEventListener("scroll",onScroll);
          scroller=nextScroller;
          scroller.addEventListener("scroll",onScroll,{passive:true});
        }
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      });
    },{passive:true});
    if(window.visualViewport){
      window.visualViewport.addEventListener("resize",syncViewportHeight,{passive:true});
    }
    window.addEventListener("orientationchange",function(){
      setTimeout(function(){
        syncViewportHeight();
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      },120);
    },{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120);
    }
    loaderBar.style.width="62%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700);
    }else done();

    setActive(activeFromViewport());
    targetP=timelineProgress();
    currentP=targetP;
    stageRender(currentP);
  }

  function start(scope){
    (scope||document).querySelectorAll("[data-mtx]").forEach(init);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){start(document)});
  }else{
    start(document);
  }

  document.addEventListener("shopify:section:load",function(e){start(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtx-bak-pre-cream-2058"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function ease(t){t=clamp(t,0,1);return t*t*(3-2*t)}

  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready="1";

    var pageWrapper=document.querySelector(".page-wrapper");
    var scroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
    var story=root.querySelector("[data-story]");
    var stage=root.querySelector("[data-stage]");
    var steps=[].slice.call(root.querySelectorAll("[data-step]"));
    var rail=[].slice.call(root.querySelectorAll("[data-rail] span"));
    var navButtons=[].slice.call(root.querySelectorAll("[data-nav] [data-jump]"));
    var product=root.querySelector("[data-product]");
    var productImg=root.querySelector("[data-product-img]");
    var halo=root.querySelector("[data-halo]");
    var orbitOne=root.querySelector("[data-orbit-one]");
    var orbitTwo=root.querySelector("[data-orbit-two]");
    var dotOne=root.querySelector("[data-dot-one]");
    var dotTwo=root.querySelector("[data-dot-two]");
    var cream=root.querySelector("[data-bg-cream]");
    var shadow=root.querySelector("[data-shadow]");
    var bar=root.querySelector("[data-progress]");
    var loader=root.querySelector("[data-loader]");
    var loaderBar=root.querySelector("[data-loader-bar]");
    var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function syncViewportHeight(){
      if(window.innerWidth>720){
        root.style.removeProperty("--mtx-vh");
        return;
      }
      var h=(window.visualViewport&&window.visualViewport.height)||window.innerHeight||document.documentElement.clientHeight;
      if(h>0)root.style.setProperty("--mtx-vh",Math.round(h)+"px");
    }
    syncViewportHeight();

    var active=-1;
    var currentP=0;
    var targetP=0;
    var raf=0;

    var desktopFrames=[
      {x:68,y:51,s:1.00,light:0,halo:.92,orbit:.58},
      {x:67,y:50,s:1.07,light:1,halo:.72,orbit:.18},
      {x:35,y:50,s:1.14,light:1,halo:.64,orbit:.10},
      {x:69,y:66,s:1.50,light:1,halo:.48,orbit:.00},
      {x:31,y:36,s:1.48,light:1,halo:.46,orbit:.00},
      {x:69,y:50,s:.86,light:0,halo:.72,orbit:.26},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:1.00,light:0,halo:.76,orbit:.00},
      {x:35,y:50,s:.92,light:0,halo:.80,orbit:.00},
      {x:69,y:50,s:1.08,light:0,halo:.82,orbit:.24},
      {x:78,y:49,s:.68,light:1,halo:.50,orbit:.12}
    ];

    var tabletFrames=[
      {x:67,y:51,s:.96,light:0,halo:.90,orbit:.50},
      {x:66,y:50,s:1.00,light:1,halo:.70,orbit:.16},
      {x:34,y:50,s:1.04,light:1,halo:.62,orbit:.10},
      {x:67,y:62,s:1.24,light:1,halo:.48,orbit:.00},
      {x:33,y:38,s:1.22,light:1,halo:.46,orbit:.00},
      {x:67,y:50,s:.84,light:0,halo:.70,orbit:.22},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.94,light:0,halo:.74,orbit:.00},
      {x:34,y:50,s:.89,light:0,halo:.78,orbit:.00},
      {x:67,y:50,s:1.00,light:0,halo:.80,orbit:.20},
      {x:76,y:49,s:.66,light:1,halo:.48,orbit:.10}
    ];

    var mobileFrames=[
      {x:50,y:28.5,s:.92,light:0,halo:.86,orbit:.44},
      {x:50,y:28.0,s:.97,light:1,halo:.64,orbit:.12},
      {x:50,y:28.0,s:1.02,light:1,halo:.58,orbit:.08},
      {x:50,y:27.0,s:1.13,light:1,halo:.42,orbit:.00},
      {x:50,y:27.0,s:1.13,light:1,halo:.42,orbit:.00},
      {x:50,y:28.5,s:.87,light:0,halo:.66,orbit:.18},
      {x:50,y:28.5,s:.95,light:0,halo:.70,orbit:.00},
      {x:50,y:28.5,s:.95,light:0,halo:.70,orbit:.00},
      {x:50,y:28.5,s:.90,light:0,halo:.74,orbit:.00},
      {x:50,y:28.5,s:1.00,light:0,halo:.76,orbit:.16},
      {x:50,y:27.5,s:.76,light:1,halo:.44,orbit:.08}
    ];

    function scrollTop(){
      return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop;
    }
    function viewportH(){
      return scroller===window?(window.innerHeight||document.documentElement.clientHeight):scroller.clientHeight;
    }
    function storyTop(){
      if(scroller===window)return scrollTop()+story.getBoundingClientRect().top;
      var sr=scroller.getBoundingClientRect();
      return scroller.scrollTop+(story.getBoundingClientRect().top-sr.top);
    }
    function timelineProgress(){
      if(!steps.length)return 0;
      var base=scroller===window?0:scroller.getBoundingClientRect().top;
      var marker=viewportH()*.52;
      var centers=steps.map(function(step){
        var r=step.getBoundingClientRect();
        return (r.top-base)+r.height*.5;
      });
      if(marker<=centers[0])return 0;
      var last=centers.length-1;
      if(marker>=centers[last])return 1;
      for(var i=0;i<last;i++){
        if(marker>=centers[i]&&marker<=centers[i+1]){
          var span=Math.max(1,centers[i+1]-centers[i]);
          var local=(marker-centers[i])/span;
          return (i+clamp(local,0,1))/last;
        }
      }
      return 0;
    }
    function activeFromViewport(){
      if(window.innerWidth<=720){
        var base=scroller===window?0:scroller.getBoundingClientRect().top;
        var vh=viewportH();
        var best=0;
        var bestVisible=-1;
        steps.forEach(function(step,i){
          var r=step.getBoundingClientRect();
          var top=r.top-base;
          var bottom=r.bottom-base;
          var visible=Math.max(0,Math.min(bottom,vh)-Math.max(top,0));
          if(visible>bestVisible){
            bestVisible=visible;
            best=i;
          }
        });
        return best;
      }
      return Math.round(timelineProgress()*(steps.length-1));
    }
    function setActive(i){
      i=clamp(i,0,steps.length-1);
      if(active===i)return;
      active=i;
      steps.forEach(function(step,k){step.classList.toggle("is-active",k===i)});
      rail.forEach(function(el,k){el.classList.toggle("is-active",k===i)});
      root.classList.toggle("is-light",[1,2,3,4,10].indexOf(i)>-1);
      root.classList.toggle("is-spray",i===7);
      root.classList.toggle("is-breath",i===8);
      var navGroup=i<3?0:(i<6?1:(i<10?2:3));
      navButtons.forEach(function(btn,k){btn.classList.toggle("is-active",k===navGroup)});
    }
    function stageRender(p){
      var frames=window.innerWidth<=720?mobileFrames:(window.innerWidth<=1100?tabletFrames:desktopFrames);
      var n=frames.length-1;
      var exact=clamp(p,0,1)*n;
      var a=Math.floor(exact);
      var b=Math.min(n,a+1);
      var t=ease(exact-a);
      var fa=frames[a],fb=frames[b];

      var x=lerp(fa.x,fb.x,t);
      var y=lerp(fa.y,fb.y,t);
      var s=lerp(fa.s,fb.s,t);
      var light=lerp(fa.light,fb.light,t);
      var haloOpacity=lerp(fa.halo,fb.halo,t);
      var orbitOpacity=lerp(fa.orbit,fb.orbit,t);

      product.style.left=x+"%";
      product.style.top=y+"%";
      product.style.transform="translate3d(-50%,-50%,0) scale("+s+")";
      halo.style.left=x+"%";
      halo.style.top=y+"%";
      orbitOne.style.left=x+"%";
      orbitOne.style.top=y+"%";
      orbitTwo.style.left=x+"%";
      orbitTwo.style.top=y+"%";
      dotOne.style.left=x+"%";
      dotOne.style.top=y+"%";
      dotTwo.style.left=x+"%";
      dotTwo.style.top=y+"%";

      cream.style.opacity=light.toFixed(3);
      halo.style.opacity=haloOpacity.toFixed(3);
      orbitOne.style.opacity=orbitOpacity.toFixed(3);
      orbitTwo.style.opacity=(orbitOpacity*.62).toFixed(3);
      dotOne.style.opacity=(orbitOpacity*.92).toFixed(3);
      dotTwo.style.opacity=(orbitOpacity*.72).toFixed(3);
      shadow.style.opacity=clamp(.82-(s-1)*.18,.48,.88).toFixed(3);

      var rot=p*360;
      orbitOne.style.transform="translate3d(-50%,-50%,0) rotate("+rot+"deg)";
      orbitTwo.style.transform="translate3d(-50%,-50%,0) rotate("+(-rot*.78)+"deg)";

      var mobile=window.innerWidth<=720;
      var r1=Math.min(282,window.innerWidth*(mobile?.34:.18));
      var r2=Math.min(198,window.innerWidth*(mobile?.23:.13));
      dotOne.style.transform="rotate("+rot+"deg) translateY("+(-r1)+"px)";
      dotTwo.style.transform="rotate("+(-rot*.78)+"deg) translateY("+(-r2)+"px)";
      bar.style.width=(p*100).toFixed(2)+"%";
    }
    function tick(){
      currentP+=(targetP-currentP)*.16;
      if(Math.abs(targetP-currentP)<.0005)currentP=targetP;
      stageRender(currentP);
      if(Math.abs(targetP-currentP)>.0005){raf=requestAnimationFrame(tick)}else{raf=0}
    }
    function onScroll(){
      targetP=timelineProgress();
      setActive(activeFromViewport());
      if(reduced){
        currentP=targetP;
        stageRender(currentP);
        return;
      }
      if(!raf)raf=requestAnimationFrame(tick);
    }
    function jumpTo(index){
      var step=steps[clamp(index,0,steps.length-1)];
      if(!step)return;
      if(scroller===window){
        var top=(window.scrollY||document.documentElement.scrollTop)+step.getBoundingClientRect().top;
        window.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }else{
        var sr=scroller.getBoundingClientRect();
        var top=scroller.scrollTop+(step.getBoundingClientRect().top-sr.top);
        scroller.scrollTo({top:top,behavior:reduced?"auto":"smooth"});
      }
    }

    root.querySelectorAll("[data-jump]").forEach(function(btn){
      btn.addEventListener("click",function(){jumpTo(parseInt(btn.dataset.jump,10)||0)});
    });

    if(stage&&!reduced&&window.matchMedia("(pointer:fine)").matches){
      stage.addEventListener("pointermove",function(e){
        var r=stage.getBoundingClientRect();
        var px=clamp((e.clientX-r.left)/r.width,0,1)-.5;
        var py=clamp((e.clientY-r.top)/r.height,0,1)-.5;
        productImg.style.setProperty("--tilt-x",(px*2.4).toFixed(2)+"deg");
        productImg.style.setProperty("--tilt-y",(-py*1.8).toFixed(2)+"deg");
      });
      stage.addEventListener("pointerleave",function(){
        productImg.style.setProperty("--tilt-x","0deg");
        productImg.style.setProperty("--tilt-y","0deg");
      });
    }

    scroller.addEventListener("scroll",onScroll,{passive:true});
    var resizeRaf=0;
    window.addEventListener("resize",function(){
      syncViewportHeight();
      if(resizeRaf)return;
      resizeRaf=requestAnimationFrame(function(){
        resizeRaf=0;
        var nextScroller=(window.innerWidth>=990&&pageWrapper)?pageWrapper:window;
        if(nextScroller!==scroller){
          scroller.removeEventListener("scroll",onScroll);
          scroller=nextScroller;
          scroller.addEventListener("scroll",onScroll,{passive:true});
        }
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      });
    },{passive:true});
    if(window.visualViewport){
      window.visualViewport.addEventListener("resize",syncViewportHeight,{passive:true});
    }
    window.addEventListener("orientationchange",function(){
      setTimeout(function(){
        syncViewportHeight();
        targetP=timelineProgress();
        currentP=targetP;
        setActive(activeFromViewport());
        stageRender(currentP);
      },120);
    },{passive:true});

    function done(){
      loaderBar.style.width="100%";
      setTimeout(function(){loader.classList.add("is-hidden")},120);
    }
    loaderBar.style.width="62%";
    if(productImg&&productImg.complete&&productImg.naturalWidth)done();
    else if(productImg){
      productImg.addEventListener("load",done,{once:true});
      productImg.addEventListener("error",done,{once:true});
      setTimeout(done,1700);
    }else done();

    setActive(activeFromViewport());
    targetP=timelineProgress();
    currentP=targetP;
    stageRender(currentP);
  }

  function start(scope){
    (scope||document).querySelectorAll("[data-mtx]").forEach(init);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){start(document)});
  }else{
    start(document);
  }

  document.addEventListener("shopify:section:load",function(e){start(e.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
